import { createAsyncThunk, createSlice, isAnyOf, isFulfilled, isRejected } from '@reduxjs/toolkit'
import { AppDispatch, RootState, store } from '../../app/store'
import {
    AddShipToPayload,
    CustomerIDInfoRow,
    fetchContacts,
    fetchCustomer,
    fetchCustomerIdInfo,
    fetchCustomers,
} from '../customer/customerAPI'
import {
    DateToString,
    getContacts,
    PACustomerContactViewRow,
    selectCustomer,
} from '../customer/customerSlice'
import { v4 as uuidv4 } from 'uuid'
import {
    fetchDeleteAttachment,
    fetchInitOrder,
    fetchSaveOrder,
    fetchUpdateAttachment,
    fetchUploadAttachment,
    OrderSavePayload,
    OrderMiscInfoPayload,
    fetchOrderMiscInfo,
    OrderMiscInfoReturnPayload,
    fetchRebateStatus,
    makeAnalyticsKey,
    fetchPartsAvailability,
    GetOrderParams,
    fetchPricingStatistics,
    FetchPricingStatisticsReturnPayload,
    OrderHistoryReturn,
    OrderHistoryParams,
    fetchOrderHistory,
    fetchCopyOrder,
    LeadTimeHistoryReturnPayload,
    fetchCarrierServiceOptions,
    fetchFreightTerms,
    fetchVendorName,
    FetchVendorNameReturnPayload,
    fetchSendQuote,
    FetchDataSheetsReturn,
    fetchDownloadPDF,
    fetchRequestQuoteChanges,
    ImportBOMReturnLI,
    ImportCommissionOrdersReturnLI,
    ImportCommissionOrdersReturn,
    // EstimatedDeliveryParams,
    // GetEstimatedDeliveryDateParams,
} from './orderAPI'
import { COUNTRY_TABLE, CUSTOMER_TYPES } from '../../consts'
import {
    FetchRebateStatusReturnPayload,
    fetchPriceInfo,
    FetchPriceReturnPayload,
    fetchLeadTimeHistory,
} from './orderAPI'
import { useState } from 'react'
import {
    SEARCHING,
    PartsAvailabilityReturnPayload,
    fetchOrder,
    EstimatedDeliveryReturnPayload,
    fetchEstimatedDelivery,
} from './orderAPI'
import {
    FetchRebateAnalyticsParams,
    FetchRebateAnalytics,
    FetchRebateAnalyticsReturnPayload,
} from './orderAPI'
import { fetchPartInfo, FetchPartInfoReturnPayload } from '../inventory/inventoryAPI'
import { getNumDecimalPlaces } from '../../utils'
import { fqAlert } from '../../GlobalComponents/NotificationManager/NotificationManager'
import _ from 'lodash'
import { CarrierServiceOptionsReturnPayload, FreightTermsReturnPayload } from './orderAPI'
import { User } from '../meta/metaAPI'
// import { User } from '../meta/metaAPI'
import { acquireOrderLock, forceReleaseOrderLock, releaseOrderLock } from '../lock/lockSlice'
import { PayloadAction } from '@reduxjs/toolkit'
import { GetOrderReturnPayload, fetchDataSheets } from './orderAPI'
import { constants } from 'fs'
import { startOfYesterday } from 'date-fns/esm'

enum MODALS {
    NONE = 'NONE',
    UPDATE = 'UPDATE',
    MODIFY = 'MODIFY',
    RECIPIENT = 'RECIPIENT',
    ADD_CONTACT = 'ADD_CONTACT',
}

export enum LOADING_STATES {
    INIT = 'INIT', // nothing tried
    LOADING = 'LOADING',
    DONE = 'DONE',
    FAILED = 'FAILED',
}

type OrderHistoryDetailCategories = 'domain' | 'customer' | 'contact'
type OrderHistoryDetails = {
    [key in OrderHistoryDetailCategories]: string
} & {
    [key in `${OrderHistoryDetailCategories}MostRecent`]?: OrderHistoryReturn[number]
} & {
    [key in `${OrderHistoryDetailCategories}Amount`]: number
}

const updateOrderNumber = (state: OrderState, newOrderNumber: string) => {
    state.orderHeader.forEach((row) => {
        row.OrderNumber = newOrderNumber
        row.OrderDetailView.forEach((row) => {
            row.OrderNumber = newOrderNumber
        })
        row.ProgressBillingScheduleView.forEach((row) => {
            row.SalesOrderNumber = newOrderNumber
        })
        row.OrderFilenames.forEach((row) => {
            row.OrderNumber = newOrderNumber
        })
    })

    state.orderFilenames.forEach((row) => {
        row.OrderNumber = newOrderNumber
    })
}

let saveSnapShot: OrderState
export const needsSave = (): boolean => {
    let state = store.getState()
    if (state.order.orderHeader.length === 0) return false
    // check valid date the same
    let newOrderHeader = state.order.orderHeader[0]
    // if only temp row dont save
    if (newOrderHeader.OrderDetailView.length === 1) return false
    let oldOrderHeader = saveSnapShot.orderHeader[0]
    // new orders always need save -- currentAccount is only defined if making quote
    if (state.order.currentAccount && !oldOrderHeader) {
        return true
    }
    if (newOrderHeader.QuoteExpirationDate) {
        if (
            !oldOrderHeader.QuoteExpirationDate ||
            newOrderHeader.QuoteExpirationDate !== oldOrderHeader.QuoteExpirationDate
        ) {
            return true
        }
    }
    //customer ref
    if (newOrderHeader.RFQNumber !== oldOrderHeader.RFQNumber) {
        return true
    }
    //shipTo
    if (state.order.currentShipTo?.ShipToID !== saveSnapShot.currentShipTo?.ShipToID) {
        return true
    }
    // check if any lines need change
    let needsLineSave = newOrderHeader.OrderDetailView.some((newRow, i) => {
        let oldRow = oldOrderHeader.OrderDetailView[i]
        // oldRow doesnt exist
        if (!oldRow) return true
        let matchingKeys: Array<keyof typeof newRow> = [
            'UnitPrice',
            'OrderQuantity',
            'PartNumber',
            'NeedDate',
            'OriginalOnDockDate',
        ]
        return matchingKeys.some((key) => oldRow[key] !== newRow[key])
    })
    if (needsLineSave) return true
    return false
}
const makeTempRow = (orderNumber: string, newIndex: number) => {
    return {
        temp: true,
        includeDataSheets: false,
        rowId: uuidv4(),
        LineItemNumber: (newIndex + 1).toString().padStart(3, '0'),
        Available: 1,
        OrderAssemblyDetailView: [],
        OrderNumber: orderNumber,
        OrderEntryDate: new Date().toISOString(),
        QuotedDeliveryOverride: '',
        // defaults to match .net
        QuotedDeliveryUOM: 'D',
        TransitTime: 1,
    }
}
const updateOrderFileIds = (state: OrderState, newOrderFilenames: OrderFilenames) => {
    state.orderFilenames = newOrderFilenames
}

export const payloadToShipToRow = (payload: AddShipToPayload): CustomerShipToViewRow => {
    let newRow: CustomerShipToViewRow = {
        AccountCode: payload.accountCode,
        AvailabilityMode: '',
        QuoteAttachmentFormats: '',
        ShipToID: -1,
        ShipToAddress1: payload.address1,
        ShipToAddress2: payload.address2,
        ShipToZipcode: payload.zipcode,
        ShipToCity: payload.city,
        ShipToState: payload.state,
        ShipToCountry: payload.country,
        ShipToName: payload.name,
        isDefault: payload.isDefault,
    }
    return newRow
}

export const initOrder = createAsyncThunk('order/initOrder', async () => {
    const data = await fetchInitOrder()
    return data
})

export const quitQuote = createAsyncThunk<any, undefined, { state: RootState }>(
    'order/quitQuote',
    async (_: void, thunkAPI) => {
        thunkAPI.dispatch(releaseOrderLock())
        return
    }
)
interface RowMetaInfo {
    rebateStatus?: FetchRebateStatusReturnPayload
    priceInfo: FetchPriceReturnPayload
    partsAvailability?: PartsAvailabilityReturnPayload
    priceStatistics?: FetchPricingStatisticsReturnPayload
    partInfo?: FetchPartInfoReturnPayload
    leadTimeHistory?: LeadTimeHistoryReturnPayload
    estimatedDelivery?: EstimatedDeliveryReturnPayload
    vendorName?: FetchVendorNameReturnPayload
    dataSheets?: FetchDataSheetsReturn
}
// show show typehints if temp isn't true
export type PayloadOrderDetailViewRow =
    | DateToString<OrderDetailViewRow> & {
          OrderAssemblyDetailView: OrderAssemblyDetailView
          rowId: string
          metaInfo?: Partial<RowMetaInfo>
          temp: boolean
          includeDataSheets: boolean
      }
// | { temp: true; rowId: string; LineItemNumber: string }
export interface PayloadOrderHeaderViewRow extends DateToString<OrderHeaderViewRow> {
    OrderDetailView: Array<PayloadOrderDetailViewRow>
    OrderFilenames: OrderFilenames
    ProgressBillingScheduleView: ProgressBillingScheduleView
    EmailCC: string
    WebSubmitOrderURL: string
}

const ShipToAddressFromRow = (shipToRow?: CustomerShipToViewRow) => {
    return {
        ShipToName: shipToRow?.ShipToName || '',
        ShipToID: shipToRow?.ShipToID || '',
        ShipToAddress1: shipToRow?.ShipToAddress1 || '',
        ShipToAddress2: shipToRow?.ShipToAddress2 || '',
        ShipToCity: shipToRow?.ShipToCity || '',
        ShipToState: shipToRow?.ShipToState || '',
        ShipToZipcode: shipToRow?.ShipToZipcode || '',
        ShipToCountry: shipToRow?.ShipToCountry || '',
    }
}

const BillToAddressFromAccount = (account: PACustomerContactViewRow) => {
    return {
        BillToName: account.BillToName,
        BillToAddress1: account.BillToAddress1,
        BillToAddress2: account.BillToAddress2,
        BillToCity: account.BillToCity,
        BillToState: account.BillToState,
        BillToZipcode: account.BillToZipcode,
        // TODO because of getCustomer vs loaded in search differences
        BillToCountry:
            account.BillToCountry ||
            (account.BillToCountryName && account.BillToCountryName.trim()
                ? COUNTRY_TABLE.find(
                      (row) => row.Name === account.BillToCountryName!.trim()
                  )!.Code.padEnd(3)
                : ''),
    }
}

const cleanOrderDetail = (orderDetail: PayloadOrderDetailViewRow[]) => {
    let newOrderDetail = orderDetail
        .filter((row) => !row.temp)
        .map((row) => {
            let newRow: any = {
                ...row,
                temp: undefined,
                metaInfo: undefined,
                rowId: undefined,
                ExpectedOnDockDate: row.ExpectedOnDockDate || null,
            }
            return newRow
        })

    return newOrderDetail
}

const cleanOrderHeaderView = (state: OrderState) => {
    return {
        OrderHeaderView: [
            {
                ...state.orderHeader[0],
                OrderDetailView: cleanOrderDetail(state.orderHeader[0].OrderDetailView),
                CustomerAccountCode: state.currentAccount!.AccountCode,
                ...ShipToAddressFromRow(state.currentShipTo),
                ...BillToAddressFromAccount(state.currentAccount!),
                Contact: state.toContact
                    ? `${state.toContact.FirstName.trim()} ${state.toContact.LastName.trim()}`
                    : '',
                CardExpirationDate: undefined,
                OrderFilenames: state.orderFilenames,
                ReservedByUser: undefined,
                ReservedDate: undefined,
                ReservedFlag: false,
                TaxAuthorityCode: state.currentShipTo?.TaxAuthorityCode || 'TEMP',
            },
        ],
    }
}

export type OrderHeaderItems = {
    orderHeader: PayloadOrderHeaderViewRow
    currentAccount: PACustomerContactViewRow
    currentShipTo?: CustomerShipToViewRow
    toContact: ContactCustomerAccountCodeViewRow
    orderFilenames: OrderFilenames
}
export const cleanOrderHeaderLineItem = (order: OrderHeaderItems) => {
    return {
        ...order.orderHeader,
        OrderDetailView: cleanOrderDetail(order.orderHeader.OrderDetailView),
        CustomerAccountCode: order.currentAccount.AccountCode,
        ...ShipToAddressFromRow(order.currentShipTo),
        ...BillToAddressFromAccount(order.currentAccount),
        Contact: order.toContact
            ? `${order.toContact.FirstName.trim()} ${order.toContact.LastName.trim()}`
            : '',
        CardExpirationDate: undefined,
        OrderFilenames: order.orderFilenames,
        ReservedByUser: undefined,
        ReservedDate: undefined,
        ReservedFlag: false,
        TaxAuthorityCode: order.currentShipTo?.TaxAuthorityCode || 'TEMP',
    }
}

const setDefaultShippingInfo = (
    state: OrderState,
    currentCustomer: CustomerRow,
    freightTerms: FreightTermsReturnPayload,
    carrierServiceOptions: CarrierServiceOptionsReturnPayload
) => {
    state.shippingInfo.carrierKey = currentCustomer.NamedCarrierServiceKey
        ? parseInt(currentCustomer.NamedCarrierServiceKey.split(';')[0])
        : 2 // Default: UPS
    state.shippingInfo.serviceKey = currentCustomer.NamedCarrierServiceKey
        ? parseInt(currentCustomer.NamedCarrierServiceKey.split(';')[1])
        : 7 // Default: Ground
    state.shippingInfo.termsKey = currentCustomer.CarrierTermsKey
        ? currentCustomer.CarrierTermsKey
        : 4 // Default: PPA
    state.shippingInfo.collectAccount = currentCustomer.CarrierAccountCode
        ? currentCustomer.CarrierAccountCode
        : ''

    let carrier = state.carrierServiceOptions!.find(
        (row) => row.CarrierKey === state.shippingInfo.carrierKey
    )!
    let service = carrier.CarrierServices.find(
        (row) => row.CarrierServiceKey === state.shippingInfo.serviceKey
    )!

    let terms = state.freightTerms!.find((row) => row.TermsKey === state.shippingInfo.termsKey)!

    state.shippingInfo.carrier = carrier.CarrierName
    state.shippingInfo.service = service.ServiceName
    state.shippingInfo.terms = terms.ShortDescription

    // break down shipment mehtod description
    // Any time carrier service options or terms changes from API, update the list of carriers/terms
    // Set current and custom carriers based on shipment method description on startup

    let shipmentMethodDescription = state.orderHeader[0]?.ShipmentMethodDescription
    if (shipmentMethodDescription) {
        const shipmentMethodSplit = shipmentMethodDescription.split(';')
        const carrierNameShort = shipmentMethodSplit[0] ? shipmentMethodSplit[0].trim() : ''
        const serviceNameShort = shipmentMethodSplit[1] ? shipmentMethodSplit[1].trim() : ''
        const carrierServiceName = carrierNameShort + ';' + serviceNameShort
        const termsShort = shipmentMethodSplit[2] ? shipmentMethodSplit[2].trim() : ''
        const collectAccountNumber = shipmentMethodSplit[3] ? shipmentMethodSplit[3].trim() : ''

        carrierServiceOptions.forEach((carrier) => {
            if (carrier.CarrierNameABR === carrierNameShort) {
                carrier.CarrierServices.forEach((carrierService) => {
                    if (carrierService.CarrierServiceValue === carrierServiceName) {
                        state.shippingInfo.carrier = carrier.CarrierName
                        state.shippingInfo.carrierKey = carrier.CarrierKey
                        state.shippingInfo.service = carrierService.ServiceName
                        state.shippingInfo.serviceKey = carrierService.CarrierServiceKey
                    }
                })
            }
        })

        freightTerms.forEach((terms) => {
            if (terms.Terms === termsShort) {
                state.shippingInfo.termsKey = terms.TermsKey
                state.shippingInfo.terms = terms.ShortDescription

                // account # can exist
                if (termsShort === 'Col' || termsShort === '3rd') {
                    state.shippingInfo.collectAccount = collectAccountNumber
                }
            }
        })
    }
}

export interface PayloadOrderHeader {
    OrderHeaderView: Array<PayloadOrderHeaderViewRow & OrderMiscInfoReturnPayload>
    IncludeMiscInfo: boolean
    ConfirmCommissions?: boolean
    ErrorMessage?: string
}
export const saveOrder = createAsyncThunk<OrderSavePayload, any, { state: RootState }>(
    'order/saveOrder',
    async (_: void, thunkAPI) => {
        let state = thunkAPI.getState().order
        // let currentAccount = state.currentAccount!
        let invalidLines = state.invalidLines
        let dateValid = state.dateValid
        //TODO figure out why this happens
        // only get those that are currently in the table
        // invalidLines = invalidLines.filter((rowId) =>
        //     state.orderHeader[0].OrderDetailView.find((detailRow) => detailRow.rowId === rowId)
        // )
        let invalidLineItems = state.orderHeader[0].OrderDetailView.filter(
            (row) => invalidLines[row.rowId]
        )

        let lineErrors = invalidLineItems
            .map((row) => {
                let eString = `Line ${row.LineItemNumber} has an invalid `
                let err = false
                if (invalidLines[row.rowId]?.partNumber) {
                    eString += 'Part Number'
                    err = true
                }
                if (invalidLines[row.rowId]?.date) {
                    eString += err ? ' and Need Date' : 'Need Date'
                    err = true
                }
                if (invalidLines[row.rowId]?.ExpectedOnDockDate) {
                    eString += err ? ' and Estimated Date' : 'Estimated Date'
                    err = true
                }
                if (invalidLines[row.rowId]?.UnitPrice) {
                    eString += err ? ' and Unit Price' : 'Unit Price'
                    err = true
                }
                if (invalidLines[row.rowId]?.SpecialInstructions) {
                    if (err) eString += '\n and Line Item Notes required for a zero sales price.'
                    else
                        eString = `Line ${row.LineItemNumber} requires Line Item Notes for a zero sales price.`

                    err = true
                }
                return err ? eString : ''
            })
            .join('\n')
            .trim()

        // let missingNeedDateLines = state.orderHeader[0].OrderDetailView.filter(
        //     (row) =>
        //         !row.OriginalOnDockDate &&
        //         !invalidLines[row.rowId]?.date &&
        //         !row.temp &&
        //         !invalidLines[row.rowId]?.partNumber
        // )
        // let missingNeedDateErrors = missingNeedDateLines
        //     .map((row) => `Line ${row.LineItemNumber} must have a Need Date.`)
        //     .join('\n')
        //     .trim()
        let hasNontempLine = state.orderHeader[0].OrderDetailView.some((row) => !row.temp)
        let e = ''
        if (!hasNontempLine) e += 'There must be at least one valid line item to save.\n'
        if (state.addLineItemFromBOMLoading === LOADING_STATES.LOADING)
            e += 'Please wait for line items to complete loading.\n'
        if (lineErrors.length > 0) e += lineErrors + '\n'
        // if (missingNeedDateErrors.length > 0)
        //     e += missingNeedDateErrors + '\n'
        if (!dateValid) e += "Can't save with invalid 'Valid Until' date.\n"
        if (e.length > 0) {
            fqAlert({
                type: 'error',
                title: 'Save Failed.',
                message: 'Severe server error. Contact I.T.',
            })
            throw thunkAPI.rejectWithValue(e)
        }
        //@ts-ignore
        let payload: OrderSavePayload = cleanOrderHeaderView(state)
        let order = await fetchSaveOrder(payload)
        thunkAPI.dispatch(acquireOrderLock({ orderNumber: order.OrderHeaderView[0].OrderNumber }))
        return order
    }
)

interface SendQuoteParams {
    orderTo: ContactCustomerAccountCodeViewRow
    tos: (ContactCustomerAccountCodeViewRow | string)[]
    ccs: (ContactCustomerAccountCodeViewRow | string)[]
    bccs: (ContactCustomerAccountCodeViewRow | string)[]
    subject: string
    body: string
    files: OrderFilenames
    currentUser: User
}
export const sendQuote = createAsyncThunk<any, any, { state: RootState }>(
    'order/sendQuote',
    async (payload: SendQuoteParams, thunkAPI) => {
        const { tos, orderTo, currentUser, subject, body, ccs, bccs, files } = payload
        let state = thunkAPI.getState().order
        let orderHeader = state.orderHeader[0]
        const showImages = state.showImages
        let includedDataSheets = orderHeader.OrderDetailView.filter(
            (row) => row.includeDataSheets
        ).map((row) => row.PartKey!)
        let includedDataSheetsSet = new Set(includedDataSheets)
        includedDataSheets = Array.from(includedDataSheetsSet)
        let fileIds = [
            ...files.filter((row) => row.IncludeWithOrder).map((row) => row.FileId),
            includedDataSheets.map((row) => 'ds' + row.toString()),
        ].join(',')
        let params = [
            'SendQuote',
            currentUser.CompanyCode, //Company
            orderHeader.OrderNumber,
            'E', //format === Email,
            tos
                .map((row) => {
                    if (typeof row === 'string') {
                        return row
                    } else {
                        return row.EmailAddress || ''
                    }
                })
                .join(';'), //cc
            `${orderTo.FirstName.trim()} ${orderTo.LastName.trim()}`,
            'S', // display ship to
            '', // display warehouse
            'ARO', //ARO
            'True', //AttachPDF
            'True', //AttachExcel
            subject,
            body,
            'True', //attachOther
            ccs
                .map((row) => {
                    if (typeof row === 'string') {
                        return row
                    } else {
                        return row.EmailAddress || ''
                    }
                })
                .join(';'), //cc
            bccs
                .map((row) => {
                    if (typeof row === 'string') {
                        return row
                    } else {
                        return row.EmailAddress || ''
                    }
                })
                .join(';'), //bcc
            showImages ? 'True' : 'False', //show images
            'False', //suppress part numbers
            'False', //datasheet
            fileIds,
        ]
        let paramsString = params
            .join('|')
            .replaceAll('\t', '')
            .replaceAll(' ', String.fromCharCode(5))

        thunkAPI.dispatch(orderSlice.actions.incrementRevisionNumber())
        let saveSuccess = await thunkAPI.dispatch(saveOrder(null))
        if (isRejected(saveSuccess)) {
            fqAlert({
                title: 'Failed to save quote',
                message: "Couldn't save quote to increment version number.",
                type: 'error',
            })
            return
        }
        let success = await fetchSendQuote({
            paramsString,
            Username: currentUser.Username,
            Email: currentUser.Email,
        })
        success
            ? fqAlert({
                  type: 'success',
                  message: `Quote ${orderHeader.OrderNumber} Sent`,
              })
            : fqAlert({
                  title: 'Failed to send quote',
                  message: 'Failed to send quote',
                  type: 'error',
              })
        if (success) {
            thunkAPI.dispatch(quitQuote())
        }
    }
)

export const downloadPDF = createAsyncThunk<any, any, { state: RootState }>(
    'order/downloadPDF',
    async (_: void, thunkAPI) => {
        let state = thunkAPI.getState().order
        let orderHeader = state.orderHeader[0]
        let toContact = state.toContact
            ? `${state.toContact.FirstName.trim()} ${state.toContact.LastName.trim()}`
            : ''
        const showImages = state.showImages

        let pdfProm = await fetchDownloadPDF({
            OrderNumber: orderHeader.OrderNumber,
            ContactName: toContact,
            DisplayWarehouse: orderHeader.Location?.trim(),
            IncludeImages: showImages,
            OrderDate: orderHeader.OrderDate
                ? new Date(orderHeader.OrderDate).toLocaleDateString()
                : '',
        })

        pdfProm
            ? fqAlert({
                  type: 'success',
                  message: 'PDF downloaded',
              })
            : fqAlert({
                  title: 'Failed to download PDF',
                  message: 'Failed to download PDF',
                  type: 'error',
              })
    }
)
interface RequestQuoteChangesParams {
    needDate: Date
    quoteExpirationDate: Date
    comments: string
}

export const requestQuoteChanges = createAsyncThunk<any, any, { state: RootState }>(
    'order/requestQuoteChanges',
    async (payload: RequestQuoteChangesParams, thunkAPI) => {
        let state = thunkAPI.getState().order
        let orderNumber = state.orderHeader[0].OrderNumber

        let reqProm = await fetchRequestQuoteChanges({
            OrderNumber: orderNumber,
            NeedDate: payload.needDate,
            QuoteExpirationDate: payload.quoteExpirationDate,
            Comments: payload.comments,
        })

        reqProm
            ? fqAlert({
                  type: 'success',
                  message: 'Updates requested successfully',
              })
            : fqAlert({
                  type: 'error',
                  title: 'Failure',
                  message: 'Failed to request updates',
              })
    }
)
//weird but needed state check outside of redux
export const presaveCheck = createAsyncThunk<any, any, { state: RootState }>(
    'order/presaveCheck',
    async (_: void, thunkAPI) => {
        let state = thunkAPI.getState().order
        // let currentAccount = state.currentAccount!
        let invalidLines = state.invalidLines
        let dateValid = state.dateValid
        let invalidLineItems = state.orderHeader[0].OrderDetailView.filter(
            (row) => invalidLines[row.rowId]
        )

        let lineErrors = invalidLineItems
            .map((row) => {
                let eString = `Line ${row.LineItemNumber} has an invalid `
                let err = false
                if (invalidLines[row.rowId]?.partNumber) {
                    eString += 'Part Number'
                    err = true
                }
                if (invalidLines[row.rowId]?.date) {
                    eString += err ? ' and Need Date' : 'Need Date'
                    err = true
                }
                if (invalidLines[row.rowId]?.ExpectedOnDockDate) {
                    eString += err ? ' and Estimated Date' : 'Estimated Date'
                    err = true
                }
                if (invalidLines[row.rowId]?.UnitPrice) {
                    eString += err ? ' and Unit Price' : 'Unit Price'
                    err = true
                }
                if (invalidLines[row.rowId]?.SpecialInstructions) {
                    if (err) eString += ' and \n Line Item Notes required for: A Zero sales price'
                    else
                        eString = `Line ${row.LineItemNumber} requires Line Item Notes for: A Zero sales price`

                    err = true
                }
                return err ? eString : ''
            })
            .join('\n')
            .trim()

        // let missingNeedDateLines = state.orderHeader[0].OrderDetailView.filter(
        //     (row) =>
        //         !row.OriginalOnDockDate &&
        //         !invalidLines[row.rowId]?.date &&
        //         !row.temp &&
        //         !invalidLines[row.rowId]?.partNumber
        // )
        // let missingNeedDateErrors = missingNeedDateLines
        //     .map((row) => `Line ${row.LineItemNumber} must have a Need Date.`)
        //     .join('\n')
        //     .trim()
        let hasNontempLine = state.orderHeader[0].OrderDetailView.some((row) => !row.temp)
        let e = ''
        if (!hasNontempLine) e += 'There must be at least one valid line item to save.\n'

        if (state.addLineItemFromBOMLoading === LOADING_STATES.LOADING)
            e += 'Please wait for line items to complete loading.\n'

        if (lineErrors.length > 0) e += lineErrors + '\n'

        // if (missingNeedDateErrors.length > 0)
        //     e += missingNeedDateErrors + '\n'
        if (!dateValid) e += "Can't save with invalid 'Valid Until' date.\n"

        return e
    }
)

export const addLineItemFromBOM = createAsyncThunk(
    'order/addLineItemFromBOM',
    async (lineItem: ImportBOMReturnLI, thunkAPI) => {
        // const data = await fetchInitOrder()
        // @ts-ignore
        let state: RootState['order'] = thunkAPI.getState().order
        let line = lineItem.LineItem

        let partInfoPromise = fetchPartInfo({
            PartKey: line.PartKey!,
            SearchMfgPartNumberFallback: false,
        })
        let partAvailabilityPromise
        let leadTimeHistoryPromise

        partAvailabilityPromise = fetchPartsAvailability({
            Partkey: line.PartKey!,
            NeedDate: line.NeedDate ? line.NeedDate : new Date(),
            OrderNumber: line.OrderNumber,
            LineNumber: line.LineItemNumber,
            Location: state.orderHeader[0].Location!,
            Quantity: line.OrderQuantity!,
        })

        leadTimeHistoryPromise = fetchLeadTimeHistory({
            Partkey: line.PartKey as number,
            Period: 90,
        })

        let dataSheetsPromise = fetchDataSheets({ PartKey: line.PartKey! })
        // will need updated price
        let rebateStatusPromise = fetchRebateStatus({
            CustomerAccountCode: state.currentAccount!.AccountCode,
            Partkey: line.PartKey!,
            UnitCost: line.Cost!,
            UnitPrice: line.UnitPrice!,
        })

        let priceInfoPromise = fetchPriceInfo({
            CustomerAccountCode: state.currentAccount!.AccountCode,
            GetPriceAndRebate: true,
            LockInCost: 0,
            UseLastCost: false,
            Location: state.orderHeader[0].Location!,
            OrderFromCode: '',
            Partkey: line.PartKey!,
            PricingDate: new Date().toISOString(),
            Quantity: line.OrderQuantity!,
        })
        let vendorNamePromise = fetchVendorName({
            PartNumber: line.PartNumber,
            Partkey: line.PartKey as number,
        })

        let vendorName = await vendorNamePromise
        let partsAvailability = await partAvailabilityPromise
        let partInfo = await partInfoPromise
        let priceInfo = await priceInfoPromise
        let leadTimeHistory = await leadTimeHistoryPromise
        let rebateStatus = await rebateStatusPromise
        let dataSheets = await dataSheetsPromise

        return {
            dataSheets,
            partInfo,
            rebateStatus,
            partsAvailability,
            priceInfo,
            vendorName,
            leadTimeHistory,
        }
    }
)

export const getOrderMiscInfo = createAsyncThunk<
    OrderMiscInfoReturnPayload,
    any,
    { state: RootState }
>('order/getOrderMiscInfo', async (reviewQuoteMode: boolean, thunkAPI) => {
    let state = thunkAPI.getState().order
    let currentAccount = state.currentAccount!
    let payload: OrderMiscInfoPayload = {
        CalculateFreight: reviewQuoteMode,
        CalculateTax: reviewQuoteMode,
        OrderHeaderView: [
            {
                ...state.orderHeader[0],
                OrderDetailView: cleanOrderDetail(state.orderHeader[0].OrderDetailView),
                CustomerAccountCode: currentAccount.AccountCode,
                ...ShipToAddressFromRow(state.currentShipTo!),
                ...BillToAddressFromAccount(state.currentAccount!),
                CardExpirationDate: undefined,
                OrderFilenames: state.orderFilenames,
                ReservedByUser: undefined,
                ReservedDate: undefined,
                ReservedFlag: false,
                TaxAuthorityCode: state.currentShipTo?.TaxAuthorityCode || 'TEMP',
            },
        ],
    }
    return await fetchOrderMiscInfo(payload)
})

// export const getEstimatedDeliveryDate = async (
//     orderHeaderRow: PayloadOrderHeaderViewRow,
//     orderDetailRow: PayloadOrderDetailViewRow
// ) => {
// export const getEstimatedDeliveryDate = createAsyncThunk<
//     EstimatedDeliveryReturnPayload,
//     any,
//     { state: RootState }
// >('order/getEstimatedDeliveryDate', async (thunkAPI) => {
//     thunkAPI.dispatch(orderSlice.actions.incrementSaveBlockingProcessPendingCount())
//     const payload = makeEstimatedDeliveryParams(orderHeaderRow, orderDetailRow)
//     const estimatedDelivery = await fetchEstimatedDelivery(payload)
//     thunkAPI.dispatch(orderSlice.actions.incrementSaveBlockingProcessPendingCount())
//     return estimatedDelivery
// })

export interface QueryInfo<T> {
    loading: LOADING_STATES
    data: T | null
    searchKey: string
}
export const useRebateAnalytics = (customerType?: string) => {
    const [query, setQuery] = useState<QueryInfo<FetchRebateAnalyticsReturnPayload>>({
        loading:
            customerType && customerType!.toLowerCase().match(/(reseller)|(exporter)|(uncertain)/)
                ? LOADING_STATES.DONE
                : LOADING_STATES.INIT,
        data: null,
        searchKey: '',
    })
    const getRebateAnalytics = async (params: FetchRebateAnalyticsParams) => {
        let cacheKey = makeAnalyticsKey(params)
        // already searching or searched
        if (query.searchKey === cacheKey) return
        setQuery({ loading: LOADING_STATES.LOADING, data: null, searchKey: cacheKey })

        let resp = await FetchRebateAnalytics(params)
        if (resp === SEARCHING) return
        setQuery({ loading: LOADING_STATES.DONE, data: resp, searchKey: cacheKey })
    }
    return { getRebateAnalytics, query }
}

export const loadOrderHeader = async (payload: GetOrderReturnPayload) => {
    let order = payload
    let customerPromise = fetchCustomer(order.OrderHeaderView[0].CustomerAccountCode)
    let contactsPromise = fetchContacts(order.OrderHeaderView[0].CustomerAccountCode)
    let customer = await customerPromise
    let customerUniqueInfo = { EntityName: '', UniqueCustomerName: '' }
    if (customer.UniqueCustomerID)
        customerUniqueInfo = await fetchCustomerIdInfo(customer.UniqueCustomerID!)
    let contacts = await contactsPromise
    // TODO feels bad having to trim and remake the stirng
    // find all possible name matches then prefer an email address
    let possibleToContacts = contacts.filter(
        (row) =>
            `${row.FirstName.trim()} ${row.LastName.trim()}`.trim() ===
            order.OrderHeaderView[0].Contact?.trim()
    )
    let toContact = possibleToContacts.find((row) => row.EmailAddress) || possibleToContacts[0]
    let ccContacts = order.OrderHeaderView[0].EmailCC.split(';')
        .filter((row) => row)
        .map((row) => {
            let contact = contacts.find((row2) => row2.EmailAddress === row.trim())
            return contact || row
        })
    await Promise.all(
        order.OrderHeaderView[0].OrderDetailView.filter((row) => !row.temp).map((row) =>
            loadLine(
                row,
                order.OrderHeaderView[0],
                customer.AccountCode,
                order.OrderHeaderView[0].OrderNumber,
                order.OrderHeaderView[0].Location!,
                undefined,
                undefined,
                payload.IsWebUser,
                payload.IsPreview
            )
        )
    )
    let webSubmitOrderURL = order.OrderHeaderView[0].WebSubmitOrderURL
    return { order, customer, toContact, ccContacts, customerUniqueInfo, webSubmitOrderURL }
}

// naming mess here between api and redux words
export const getOrder = async (payload: GetOrderParams) => {
    let order = await fetchOrder(payload)
    return await loadOrderHeader(order)
}

const loadLine = async (
    line: any,
    orderHeader: PayloadOrderHeaderViewRow,
    accountCode: string,
    orderNumber: string,
    location: string,
    updateAvailability?: boolean,
    updatePricing?: boolean,
    isWebUser?: boolean,
    isPreview?: boolean
) => {
    if (!line.PartKey) return
    let meta: PayloadOrderDetailViewRow['metaInfo'] = {}
    let partInfoPromise = fetchPartInfo({
        PartKey: line.PartKey!,
        SearchMfgPartNumberFallback: false,
    })
    let partAvailabilityPromise
    let leadTimeHistoryPromise
    if (!isWebUser) {
        partAvailabilityPromise = fetchPartsAvailability({
            Partkey: line.PartKey!,
            NeedDate: line.NeedDate ? new Date(line.NeedDate) : new Date(),
            OrderNumber: orderNumber,
            LineNumber: line.LineItemNumber,
            Location: location,
            Quantity: line.OrderQuantity!,
        })

        leadTimeHistoryPromise = fetchLeadTimeHistory({
            Partkey: line.PartKey as number,
            Period: 90,
        })
    }

    let dataSheetsPromise = fetchDataSheets({ PartKey: line.PartKey })
    // will need updated price
    let rebateStatusPromise
    if (!updatePricing) {
        rebateStatusPromise = fetchRebateStatus({
            CustomerAccountCode: accountCode,
            Partkey: line.PartKey!,
            UnitCost: line.Cost!,
            UnitPrice: line.UnitPrice!,
        })
    }

    let priceInfoPromise = fetchPriceInfo({
        CustomerAccountCode: accountCode,
        GetPriceAndRebate: true,
        LockInCost: 0,
        UseLastCost: false,
        Location: location!,
        OrderFromCode: '',
        Partkey: line.PartKey!,
        PricingDate: new Date().toISOString(),
        Quantity: line.OrderQuantity!,
    })
    let vendorNamePromise = fetchVendorName({
        PartNumber: line.PartNumber,
        Partkey: line.PartKey as number,
    })

    if (!isPreview) {
        // let estimatedDelivery = await getEstimatedDeliveryDate(orderHeader, line)

        // const estimatedDeliveryParams = makeEstimatedDeliveryParams(orderHeader, line)
        let estimatedDeliveryPromise = fetchEstimatedDelivery(orderHeader, line)
        let estimatedDelivery = await estimatedDeliveryPromise
        if (estimatedDelivery) line.NeedDate = estimatedDelivery.EstimatedDeliveryDate
    }

    let vendorName = await vendorNamePromise
    let partsAvailability = await partAvailabilityPromise
    let partInfo = await partInfoPromise
    let priceInfo = await priceInfoPromise
    let leadTimeHistory = await leadTimeHistoryPromise

    if (updatePricing) {
        rebateStatusPromise = fetchRebateStatus({
            CustomerAccountCode: accountCode,
            Partkey: line.PartKey!,
            UnitCost: line.Cost!,
            UnitPrice: priceInfo.CustomerPrice!,
        })
        line.UnitPrice = priceInfo.CustomerPrice
    }
    if (updateAvailability) {
        line.ExpectedOnDockDate = undefined
    }

    let rebateStatus = await rebateStatusPromise
    let dataSheets = await dataSheetsPromise
    // if not error
    if (typeof dataSheets !== 'string') {
        meta.dataSheets = dataSheets
    }
    meta.partInfo = partInfo!
    meta.rebateStatus = rebateStatus
    meta.partsAvailability = partsAvailability
    meta.priceInfo = priceInfo
    meta.vendorName = vendorName
    meta.leadTimeHistory = leadTimeHistory
    line.metaInfo = meta
}
interface FreightAndCarrierOptions {
    freightTermsOptions: FreightTermsReturnPayload
    carrierServiceOptions: CarrierServiceOptionsReturnPayload
}
// export const loadCarrierAndFreight = createAsyncThunk<any, undefined, { state: RootState }>(
//     'order/loadCarrierAndFreight',
//     async (_: void, thunkAPI) => {
//         let carrierServiceOptionsPromise = fetchCarrierServiceOptions()
//         let freightTermsPromise = fetchFreightTerms()

//         let carrierServiceOptions = await carrierServiceOptionsPromise
//         let freightTermsOptions = await freightTermsPromise
//         thunkAPI.dispatch(
//             orderSlice.actions.setCarrierAndFreight({ carrierServiceOptions, freightTermsOptions })
//         )
//         return
//     }
// )
// export const loadCarrierAndFreight = createAsyncThunk('order/loadCarrierAndFreight', () => {
//     return async (dispatch: AppDispatch) => {
//         let carrierServiceOptionsPromise = fetchCarrierServiceOptions()
//         let freightTermsPromise = fetchFreightTerms()

//         let carrierServiceOptions = await carrierServiceOptionsPromise
//         let freightTermsOptions = await freightTermsPromise
//         dispatch(
//             orderSlice.actions.setCarrierAndFreight({ carrierServiceOptions, freightTermsOptions })
//         )
//     }
// })

export const loadCarrierAndFreight = createAsyncThunk(
    'order/loadCarrierAndFreight',
    async (_: void, thunkAPI) => {
        let carrierServiceOptionsPromise = fetchCarrierServiceOptions()
        let freightTermsPromise = fetchFreightTerms()

        let carrierServiceOptions = await carrierServiceOptionsPromise
        let freightTermsOptions = await freightTermsPromise
        thunkAPI.dispatch(
            orderSlice.actions.setCarrierAndFreight({ carrierServiceOptions, freightTermsOptions })
        )

        return
    }
)

// export const loadCarrierAndFreight = () => {
//     return async (dispatch: AppDispatch) => {
//         let carrierServiceOptionsPromise = fetchCarrierServiceOptions()
//         let freightTermsPromise = fetchFreightTerms()

//         let carrierServiceOptions = await carrierServiceOptionsPromise
//         let freightTermsOptions = await freightTermsPromise
//         dispatch(
//             orderSlice.actions.setCarrierAndFreight({ carrierServiceOptions, freightTermsOptions })
//         )
//     }
// }
export const loadOrder = createAsyncThunk<
    ReturnType<typeof getOrder> extends PromiseLike<infer T> ? T : never,
    GetOrderParams,
    { state: RootState }
>('order/loadOrder', async (payload: GetOrderParams, thunkAPI) => {
    let state = thunkAPI.getState()
    let initialLoadingState = state.order.orderLoading
    thunkAPI.dispatch(orderSlice.actions.setLoadingState(LOADING_STATES.LOADING))
    // let carrierAndFreightPromise = loadCarrierAndFreight()
    let carrierAndFreightPromise = thunkAPI.dispatch(loadCarrierAndFreight())

    let orderPromise = getOrder(payload)
    if (!payload.IsWebUser) {
        let lock = await thunkAPI.dispatch(acquireOrderLock({ orderNumber: payload.OrderNumber }))
        if (isFulfilled(lock) && !lock.payload.HasLock) {
            fqAlert({
                type: 'warning',
                message: `${lock.payload.LockOwner} is currently editing this quote`,
            })
            thunkAPI.dispatch(orderSlice.actions.setLoadingState(initialLoadingState))
            return thunkAPI.rejectWithValue(
                `${lock.payload.LockOwner} is currently editing this quote`
            )
        }
        if (isRejected(lock)) {
            fqAlert({
                type: 'warning',
                message: lock.payload as string,
            })
            thunkAPI.dispatch(orderSlice.actions.setLoadingState(initialLoadingState))
            return thunkAPI.rejectWithValue(lock.payload)
        }
    }
    let order = await orderPromise

    let getContactsPromise = thunkAPI.dispatch(getContacts(order.customer.AccountCode))
    // TODO fix typing
    thunkAPI.dispatch(
        //@ts-ignore
        selectCustomer({
            ...order.customer,
            EmailAddress: '',
            ExactMatch: false,
        })
    )
    thunkAPI.dispatch(orderSlice.actions.setCurrentCustomer(order.customer))
    thunkAPI.dispatch(orderSlice.actions.setCurrentCustomerUniqueInfo(order.customerUniqueInfo))
    if (!payload.IsWebUser && !payload.IsPreview) {
        thunkAPI.dispatch(
            loadHistory({
                contactEmailAddress: order.toContact?.EmailAddress || '',
                customerAccountCode: order.customer.AccountCode,
            })
        )
    }
    await getContactsPromise
    await carrierAndFreightPromise
    return order
})

export interface UpdateShipmentMethodDescriptionParams {
    ShipmentMethodString: string
}

export interface UpdateShipmentMethodDescriptionReturnPayload {
    ShipmentMethodString: string
    OrderDetailView: PayloadOrderHeaderViewRow[]
}

export const updateShipmentMethodDescription = createAsyncThunk<any, any, { state: RootState }>(
    'order/UpdateShipmentMethodDescription',
    async (payload: UpdateShipmentMethodDescriptionParams, thunkAPI) => {
        const state: OrderState = thunkAPI.getState().order
        let tempState = _.cloneDeep(state)
        tempState.orderHeader[0].ShipmentMethodDescription = payload.ShipmentMethodString

        await Promise.all(
            tempState.orderHeader[0].OrderDetailView.filter((row) => !row.temp).map(
                async (orderDetailViewRow) => {
                    let estimatedDeliveryPromise = fetchEstimatedDelivery(
                        tempState.orderHeader[0],
                        orderDetailViewRow
                    )
                    let estimatedDelivery = await estimatedDeliveryPromise
                    if (orderDetailViewRow.metaInfo) {
                        orderDetailViewRow.metaInfo = {
                            ...orderDetailViewRow.metaInfo,
                            estimatedDelivery: estimatedDelivery,
                        }
                    }
                }
            )
        )

        return {
            ShipmentMethodString: payload.ShipmentMethodString,
            OrderDetailView: tempState.orderHeader[0].OrderDetailView,
        }
    }
)

export interface UpdateShipToParams {
    shipTo: CustomerShipToViewRow
}

export interface UpdateShipToReturnPayload {
    shipTo: CustomerShipToViewRow
    OrderDetailView: PayloadOrderHeaderViewRow[]
}

export const updateShipTo = createAsyncThunk<any, UpdateShipToParams, { state: RootState }>(
    'order/UpdateShipTo',
    async (payload: UpdateShipToParams, thunkAPI) => {
        const state: OrderState = thunkAPI.getState().order
        let tempState = _.cloneDeep(state)
        tempState.currentShipTo = payload.shipTo
        await Promise.all(
            tempState.orderHeader[0].OrderDetailView.filter((row) => !row.temp).map(
                async (orderDetailViewRow) => {
                    let estimatedDeliveryPromise = fetchEstimatedDelivery(
                        tempState.orderHeader[0],
                        orderDetailViewRow
                    )
                    let estimatedDelivery = await estimatedDeliveryPromise
                    if (orderDetailViewRow.metaInfo) {
                        orderDetailViewRow.metaInfo = {
                            ...orderDetailViewRow.metaInfo,
                            estimatedDelivery: estimatedDelivery,
                        }
                    }
                }
            )
        )

        return {
            shipTo: payload.shipTo,
            OrderDetailView: tempState.orderHeader[0].OrderDetailView,
        }
    }
)

// poorly named -- the button is udpate but this loads an order an optionally updates prcing and availability
// updates are done with frontend calls
export const updateOrder = createAsyncThunk<
    ReturnType<typeof getOrder> extends PromiseLike<infer T> ? T : never,
    GetOrderParams & { UpdatePricing: boolean; UpdateAvailability: boolean },
    { state: RootState }
>(
    'order/updateOrder',
    async (
        payload: GetOrderParams & { UpdatePricing: boolean; UpdateAvailability: boolean },
        thunkAPI
    ) => {
        let { UpdatePricing, UpdateAvailability, IsWebUser } = payload
        thunkAPI.dispatch(orderSlice.actions.setLoadingState(LOADING_STATES.LOADING))

        let orderPromise = getOrder(payload)
        let lock = await thunkAPI.dispatch(acquireOrderLock({ orderNumber: payload.OrderNumber }))
        if (isFulfilled(lock) && !lock.payload.HasLock) {
            fqAlert({
                type: 'error',
                title: `${lock.payload.LockOwner} is currently editing this quote`,
            })
            thunkAPI.dispatch(orderSlice.actions.setLoadingState(LOADING_STATES.DONE))
            return thunkAPI.rejectWithValue(
                `${lock.payload.LockOwner} is currently editing this quote`
            )
        }
        if (isRejected(lock)) {
            fqAlert({
                type: 'warning',
                message: lock.payload as string,
            })
            thunkAPI.dispatch(orderSlice.actions.setLoadingState(LOADING_STATES.DONE))
            return thunkAPI.rejectWithValue(lock.payload)
        }
        let order = await orderPromise
        thunkAPI.dispatch(
            acquireOrderLock({ orderNumber: order.order.OrderHeaderView[0].OrderNumber })
        )

        thunkAPI.dispatch(orderSlice.actions.setCurrentCustomer(order.customer))
        thunkAPI.dispatch(orderSlice.actions.setCurrentCustomerUniqueInfo(order.customerUniqueInfo))
        thunkAPI.dispatch(
            loadHistory({
                contactEmailAddress: order.toContact?.EmailAddress || '',
                customerAccountCode: order.customer.AccountCode,
            })
        )
        await Promise.all(
            order.order.OrderHeaderView[0].OrderDetailView.filter((row) => !row.temp).map((row) =>
                loadLine(
                    row,
                    order.order.OrderHeaderView[0],
                    order.customer.AccountCode,
                    order.order.OrderHeaderView[0].OrderNumber,
                    order.order.OrderHeaderView[0].Location!,
                    UpdateAvailability,
                    UpdatePricing,
                    IsWebUser
                )
            )
        )
        return order
    }
)

// export const copyOrder = createAsyncThunk(
//     'order/copyOrder',
//     (payload: Parameters<typeof fetchCopyOrder>[0] & { load?: boolean }) => {
//         const { load = false } = payload
//         return async (dispatch: AppDispatch) => {
//             let newOrder = await fetchCopyOrder(payload)
//             let order = await loadOrderHeader(newOrder)
//             // only is real order number if we tell copy api to save
//             let orderNumber = order.order.OrderHeaderView[0].OrderNumber
//             if (load) {
//                 dispatch(orderSlice.actions.setLoadingState(LOADING_STATES.LOADING))
//                 dispatch(
//                     //@ts-ignore
//                     loadOrder.fulfilled(order, 'a', payload)
//                 )
//             }
//             return orderNumber
//         }
//     }
// )
export const copyOrder = (payload: Parameters<typeof fetchCopyOrder>[0] & { load?: boolean }) => {
    const { load = false } = payload
    return async (dispatch: AppDispatch) => {
        let newOrder = await fetchCopyOrder(payload)
        let order = await loadOrderHeader(newOrder)
        // only is real order number if we tell copy api to save
        let orderNumber = order.order.OrderHeaderView[0].OrderNumber
        if (load) {
            dispatch(orderSlice.actions.setLoadingState(LOADING_STATES.LOADING))
            dispatch(
                //@ts-ignore
                loadOrder.fulfilled(order, 'a', payload)
            )
        }
        return orderNumber
    }
}
export const loadHistory = createAsyncThunk(
    'order/loadHistory',
    async (payload: OrderHistoryParams, thunkAPI) => {
        let orderHistory = await fetchOrderHistory(payload)
        return { orderHistory, contact: payload.contactEmailAddress }
    }
)

export const startQuote = createAsyncThunk<any, any, { state: RootState }>(
    'order/startQuote',
    async (
        payload: {
            account: PACustomerContactViewRow
            shipTo?: CustomerShipToViewRow
            contact?: ContactCustomerAccountCodeViewRow
        },
        thunkAPI
    ) => {
        // let carrierAndFreightPromise = loadCarrierAndFreight()
        let carrierAndFreightPromise = thunkAPI.dispatch(loadCarrierAndFreight())

        //get customer to populat payment method and shipping defaults
        let customer = await fetchCustomer(payload.account.AccountCode)
        let customerUniqueInfo
        if (customer.UniqueCustomerID)
            customerUniqueInfo = await fetchCustomerIdInfo(customer.UniqueCustomerID!)
        else customerUniqueInfo = { EntityName: '', UniqueCustomerName: '' }

        await carrierAndFreightPromise
        thunkAPI.dispatch(
            orderSlice.actions.startQuoteInternal({
                ...payload,
                customer,
                customerUniqueInfo,
            })
        )
        let cust = await fetchCustomers(customer.AccountCode)
        thunkAPI.dispatch(selectCustomer(cust[0]))
        payload.contact &&
            thunkAPI.dispatch(
                loadHistory({
                    contactEmailAddress: payload.contact.EmailAddress!,
                    customerAccountCode: customer.AccountCode,
                })
            )
        // let customer = await fetchCustome()
        return await thunkAPI.dispatch(initOrder())
    }
)

export const searchQuote = createAsyncThunk<any, any, { state: RootState }>(
    'order/searchQuote',
    async (
        payload: {
            account: PACustomerContactViewRow
            shipTo?: CustomerShipToViewRow
            contactEmail: string
            customerAccountCode: string
            contact?: ContactCustomerAccountCodeViewRow
        },
        thunkAPI
    ) => {
        // let carrierAndFreightPromise = loadCarrierAndFreight()
        let carrierAndFreightPromise = thunkAPI.dispatch(loadCarrierAndFreight())

        //get customer to populat payment method and shipping defaults
        let customer = await fetchCustomer(payload.customerAccountCode)
        let customerUniqueInfo
        if (customer.UniqueCustomerID)
            customerUniqueInfo = await fetchCustomerIdInfo(customer.UniqueCustomerID!)
        else customerUniqueInfo = { EntityName: '', UniqueCustomerName: '' }

        await carrierAndFreightPromise
        thunkAPI.dispatch(
            orderSlice.actions.startQuoteInternal({
                ...payload,
                customer,
                customerUniqueInfo,
            })
        )

        let cust = await fetchCustomers(customer.AccountCode)
        thunkAPI.dispatch(selectCustomer(cust[0]))
        // payload.contactEmail &&
        thunkAPI.dispatch(
            loadHistory({
                contactEmailAddress: payload.contactEmail || '',
                customerAccountCode: payload.customerAccountCode,
            })
        )
        return await thunkAPI.dispatch(initOrder())
    }
)
// export const startQuote = (payload: {
//     account: PACustomerContactViewRow
//     shipTo?: CustomerShipToViewRow
//     contact?: ContactCustomerAccountCodeViewRow
// }) => {
//     return async (dispatch: ThunkDispatch<RootState, null, AnyAction>) => {
//         // let carrierAndFreightPromise = loadCarrierAndFreight()
//         let carrierAndFreightPromise = dispatch(loadCarrierAndFreight())

//         //get customer to populat payment method and shipping defaults
//         let customer = await fetchCustomer(payload.account.AccountCode)
//         let customerUniqueInfo
//         if (customer.UniqueCustomerID)
//             customerUniqueInfo = await fetchCustomerIdInfo(customer.UniqueCustomerID!)
//         else customerUniqueInfo = { EntityName: '', UniqueCustomerName: '' }

//         await carrierAndFreightPromise
//         dispatch(
//             orderSlice.actions.startQuoteInternal({
//                 ...payload,
//                 customer,
//                 customerUniqueInfo,
//             })
//         )
//         payload.contact &&
//             dispatch(
//                 loadHistory({
//                     contactEmailAddress: payload.contact.EmailAddress!,
//                     customerAccountCode: customer.AccountCode,
//                 })
//             )
//         // let customer = await fetchCustome()
//         return await dispatch(initOrder())
//     }
// }
export interface UploadAttachmentPayload {
    fileData: string
    contentType: string
    fileName: string
}

export const uploadAttachment = createAsyncThunk(
    'order/uploadAttachment',
    async (payload: UploadAttachmentPayload, thunkAPI) => {
        return await fetchUploadAttachment(payload)
    }
)

export const deleteAttachment = createAsyncThunk(
    'order/deleteAttachment',
    async (fileId: number) => {
        await fetchDeleteAttachment(fileId)
    }
)

export interface UpdateAttachmentPayload {
    fileId: number
    internal: boolean
}
export const updateAttachment = createAsyncThunk(
    'order/updateAttachment',
    async (payload: UpdateAttachmentPayload, thunkAPI) => {
        return await fetchUpdateAttachment(1)
    }
)

// you will want to pass all relevant data from the order header/line, eg: partkey, cust acct code,
//quantity and location. Pricing date should always be today (for now). getpriceandrebate should
//always be true, locin cost be 0, and uselastcost should be false
//TODO stale?
// ! NOT IMMER !
// export const updateLine = createAsyncThunk(
//     'order/updateLine',
//     (payload: { rowId: string } & Partial<PayloadOrderDetailViewRow>) => {
//         return async (dispatch: AppDispatch, getState: () => RootState) => {
//             let wholeState = getState()
//             let state = wholeState.order
//             let existingRow = state.orderHeader[0].OrderDetailView.find(
//                 (row) => row.rowId === payload.rowId
//             )!
//             let partKey = payload.PartKey || existingRow?.PartKey
//             // was a blank row or it changed partkeys
//             let isNewRow =
//                 existingRow.temp || (payload.PartKey && existingRow!.PartKey !== payload.PartKey)
//             let priceInfo
//             let priceInfoPromise
//             if (payload.PartKey || payload.OrderQuantity || payload.UnitPrice) {
//                 priceInfoPromise = fetchPriceInfo({
//                     Price: isNewRow ? undefined : payload.UnitPrice || existingRow!.UnitPrice,
//                     CustomerAccountCode: state.currentAccount!.AccountCode,
//                     GetPriceAndRebate: true,
//                     LockInCost: 0,
//                     UseLastCost: false,
//                     Location: state.orderHeader[0].Location!,
//                     OrderFromCode: '',
//                     Partkey: payload.PartKey || (existingRow!.PartKey as number),
//                     PricingDate: new Date().toISOString(),
//                     Quantity: payload.OrderQuantity || (existingRow!.OrderQuantity as number),
//                 })
//             }
//             let dataSheetPromise
//             if (isNewRow && payload.PartKey) {
//                 dataSheetPromise = fetchDataSheets({ PartKey: payload.PartKey })
//             }
//             priceInfo = priceInfoPromise ? await priceInfoPromise : existingRow.metaInfo?.priceInfo!

//             //TODO these awaits shouldn't all be serial
//             let priceStatistics
//             let priceStatisticsPromise
//             let partInfo
//             let partInfoPromise
//             let leadTimeHistoryPromise
//             let leadTimeHistory
//             let estimatedDeliveryPromise
//             let estimatedDelivery
//             let vendorNamePromise
//             let vendorName

//             if (payload.NeedDate || payload.OrderQuantity) {
//                 let cleanOrderHeader = cleanOrderHeaderView(state).OrderHeaderView
//                 cleanOrderHeader[0].OrderDetailView = [
//                     {
//                         PartKey: existingRow!.PartKey as number,
//                         OrderQuantity:
//                             payload.OrderQuantity || (existingRow!.OrderQuantity as number) || 1,
//                         PartNumber: existingRow.PartNumber,
//                         OrderNumber: existingRow!.OrderNumber,
//                         LineItemNumber: existingRow!.LineItemNumber,
//                     },
//                 ]
//                 estimatedDeliveryPromise = fetchEstimatedDelivery({
//                     OrderHeaderView: cleanOrderHeader,
//                 })
//                 estimatedDelivery = await estimatedDeliveryPromise
//                 leadTimeHistoryPromise = fetchLeadTimeHistory({
//                     Partkey: payload.PartKey || (existingRow!.PartKey as number),
//                     Period: 90,
//                 })
//                 leadTimeHistory = await leadTimeHistoryPromise
//             }
//             if (payload.PartKey) {
//                 let cleanOrderHeader = cleanOrderHeaderView(state).OrderHeaderView
//                 cleanOrderHeader[0].OrderDetailView = [
//                     {
//                         PartKey: payload.PartKey || (existingRow!.PartKey as number),
//                         OrderQuantity:
//                             payload.OrderQuantity || (existingRow!.OrderQuantity as number) || 1,
//                         PartNumber: payload.PartNumber || existingRow.PartNumber,
//                         OrderNumber: payload.OrderNumber || existingRow!.OrderNumber,
//                         LineItemNumber: payload.LineItemNumber || existingRow!.LineItemNumber,
//                     },
//                 ]
//                 vendorNamePromise = fetchVendorName({
//                     Partkey: payload.PartKey || (existingRow!.PartKey as number),
//                 })
//                 estimatedDeliveryPromise = fetchEstimatedDelivery({
//                     OrderHeaderView: cleanOrderHeader,
//                 })
//                 priceStatisticsPromise = fetchPricingStatistics({
//                     Partkey: payload.PartKey,
//                     CustomerAccountCode: state.currentAccount!.AccountCode,
//                 })
//                 leadTimeHistoryPromise = fetchLeadTimeHistory({
//                     Partkey: payload.PartKey,
//                     Period: 90,
//                 })
//                 partInfoPromise = fetchPartInfo({ PartKey: payload.PartKey, SearchMfgPartNumberFallback: false })
//                 priceStatistics = await priceStatisticsPromise
//                 partInfo = await partInfoPromise
//                 estimatedDelivery = await estimatedDeliveryPromise
//                 vendorName = await vendorNamePromise

//                 leadTimeHistory = await leadTimeHistoryPromise
//             }
//             let partAvailabilityPromise
//             if (payload.PartKey || payload.OrderQuantity || payload.NeedDate) {
//                 partAvailabilityPromise = fetchPartsAvailability({
//                     Partkey: partKey!,
//                     NeedDate:
//                         (payload.NeedDate && new Date(payload.NeedDate)) ||
//                         (existingRow.NeedDate && new Date(existingRow.NeedDate)) ||
//                         new Date(),
//                     OrderNumber: state.orderHeader[0].OrderNumber,
//                     LineNumber: existingRow!.LineItemNumber,
//                     Location: state.orderHeader[0].Location!,
//                     Quantity: payload.OrderQuantity || existingRow.OrderQuantity!,
//                 })
//             }
//             let rebateStatusPromise
//             if (payload.PartKey || payload.Cost || payload.UnitPrice) {
//                 rebateStatusPromise = fetchRebateStatus({
//                     CustomerAccountCode: state.currentAccount!.AccountCode,
//                     Partkey: payload.PartKey || (existingRow!.PartKey as number),
//                     UnitCost: priceInfo.Cost,
//                     UnitPrice: payload.UnitPrice || (existingRow!.UnitPrice as number),
//                 })
//             }

//             let partsAvailability = partAvailabilityPromise
//                 ? await partAvailabilityPromise
//                 : undefined
//             let rebateStatus = rebateStatusPromise ? await rebateStatusPromise : undefined
//             let dataSheets = dataSheetPromise ? await dataSheetPromise : undefined
//             // if error
//             if (typeof dataSheets === 'string') {
//                 dataSheets = undefined
//             }
//             dispatch(
//                 orderSlice.actions.updateLine2({
//                     ...payload,
//                     rebateStatus,
//                     priceInfo,
//                     partsAvailability,
//                     priceStatistics,
//                     partInfo: partInfo || undefined,
//                     estimatedDelivery,
//                     leadTimeHistory,
//                     vendorName,
//                     dataSheets,
//                 })
//             )
//         }
//     }
// )

export const updateLine = (payload: { rowId: string } & Partial<PayloadOrderDetailViewRow>) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        let wholeState = getState()
        let state = wholeState.order
        let existingRow = state.orderHeader[0].OrderDetailView.find(
            (row) => row.rowId === payload.rowId
        )!
        let partKey = payload.PartKey || existingRow?.PartKey
        // was a blank row or it changed partkeys
        let isNewRow =
            existingRow.temp || (payload.PartKey && existingRow!.PartKey !== payload.PartKey)
        let priceInfo
        let priceInfoPromise
        if (payload.PartKey || payload.OrderQuantity || payload.UnitPrice) {
            priceInfoPromise = fetchPriceInfo({
                Price: isNewRow ? undefined : payload.UnitPrice || existingRow!.UnitPrice,
                CustomerAccountCode: state.currentAccount!.AccountCode,
                GetPriceAndRebate: true,
                LockInCost: 0,
                UseLastCost: false,
                Location: state.orderHeader[0].Location!,
                OrderFromCode: '',
                Partkey: payload.PartKey || (existingRow!.PartKey as number),
                PricingDate: new Date().toISOString(),
                Quantity: payload.OrderQuantity || (existingRow!.OrderQuantity as number),
            })
        }
        let dataSheetPromise
        if (isNewRow && payload.PartKey) {
            dataSheetPromise = fetchDataSheets({ PartKey: payload.PartKey })
        }
        priceInfo = priceInfoPromise ? await priceInfoPromise : existingRow.metaInfo?.priceInfo!

        //TODO these awaits shouldn't all be serial
        let priceStatistics
        let priceStatisticsPromise
        let partInfo
        let partInfoPromise
        let leadTimeHistoryPromise
        let leadTimeHistory
        let estimatedDeliveryPromise
        let estimatedDelivery
        let vendorNamePromise
        let vendorName

        if (payload.NeedDate || payload.OrderQuantity) {
            estimatedDeliveryPromise = fetchEstimatedDelivery(
                cleanOrderHeaderView(state).OrderHeaderView[0],
                existingRow
            )
            estimatedDelivery = await estimatedDeliveryPromise
            leadTimeHistoryPromise = fetchLeadTimeHistory({
                Partkey: payload.PartKey || (existingRow!.PartKey as number),
                Period: 90,
            })
            leadTimeHistory = await leadTimeHistoryPromise
        }
        if (payload.PartKey) {
            vendorNamePromise = fetchVendorName({
                Partkey: payload.PartKey || (existingRow!.PartKey as number),
                PartNumber: payload.PartNumber || existingRow!.PartNumber,
            })

            estimatedDeliveryPromise = fetchEstimatedDelivery(
                cleanOrderHeaderView(state).OrderHeaderView[0],
                existingRow
            )

            priceStatisticsPromise = fetchPricingStatistics({
                Partkey: payload.PartKey,
                CustomerAccountCode: state.currentAccount!.AccountCode,
            })
            leadTimeHistoryPromise = fetchLeadTimeHistory({
                Partkey: payload.PartKey,
                Period: 90,
            })
            partInfoPromise = fetchPartInfo({
                PartKey: payload.PartKey,
                SearchMfgPartNumberFallback: false,
            })
            priceStatistics = await priceStatisticsPromise
            partInfo = await partInfoPromise
            estimatedDelivery = await estimatedDeliveryPromise
            vendorName = await vendorNamePromise

            leadTimeHistory = await leadTimeHistoryPromise
        }
        let partAvailabilityPromise
        if (payload.PartKey || payload.OrderQuantity || payload.NeedDate) {
            partAvailabilityPromise = fetchPartsAvailability({
                Partkey: partKey!,
                NeedDate:
                    (payload.NeedDate && new Date(payload.NeedDate)) ||
                    (existingRow.NeedDate && new Date(existingRow.NeedDate)) ||
                    new Date(),
                OrderNumber: state.orderHeader[0].OrderNumber,
                LineNumber: existingRow!.LineItemNumber,
                Location: state.orderHeader[0].Location!,
                Quantity: payload.OrderQuantity || existingRow.OrderQuantity!,
            })
        }
        let rebateStatusPromise
        if (payload.PartKey || payload.Cost || payload.UnitPrice) {
            rebateStatusPromise = fetchRebateStatus({
                CustomerAccountCode: state.currentAccount!.AccountCode,
                Partkey: payload.PartKey || (existingRow!.PartKey as number),
                UnitCost: priceInfo.Cost,
                UnitPrice: payload.UnitPrice || (existingRow!.UnitPrice as number),
            })
        }

        let partsAvailability = partAvailabilityPromise ? await partAvailabilityPromise : undefined
        let rebateStatus = rebateStatusPromise ? await rebateStatusPromise : undefined
        let dataSheets = dataSheetPromise ? await dataSheetPromise : undefined
        // if error
        if (typeof dataSheets === 'string') {
            dataSheets = undefined
        }
        dispatch(
            orderSlice.actions.updateLine2({
                ...payload,
                rebateStatus,
                priceInfo,
                partsAvailability,
                priceStatistics,
                partInfo: partInfo || undefined,
                estimatedDelivery,
                leadTimeHistory,
                vendorName,
                dataSheets,
            })
        )
    }
}

export type RowId = string

export interface ShippingInfo {
    carrier: string
    carrierKey: number
    service: string
    serviceKey: number
    terms: string
    termsKey: number
    collectAccount: string
}
export interface OrderState {
    currentAccount?: PACustomerContactViewRow
    currentCustomer?: CustomerRow
    dateValid: boolean
    currentCustomerUniqueInfo?: CustomerIDInfoRow
    currentShipTo?: CustomerShipToViewRow
    toContact?: ContactCustomerAccountCodeViewRow
    ccContacts: Array<ContactCustomerAccountCodeViewRow | string>
    currentModal: MODALS
    showImages: boolean
    webSubmitOrderURL: string
    freightTerms?: FreightTermsReturnPayload
    carrierServiceOptions?: CarrierServiceOptionsReturnPayload
    shippingInfo: ShippingInfo
    orderLoading: LOADING_STATES
    orderHeader: PayloadOrderHeader['OrderHeaderView']
    // this could have it's own slice -- just want to call it when toContact changes
    searchLoading: LOADING_STATES
    getOrderMiscInfoLoading: LOADING_STATES
    saveBlockingProcessPendingCount: number
    addLineItemFromBOMLoading: LOADING_STATES
    orderHistoryLoading: LOADING_STATES
    orderHistoryDetails?: OrderHistoryDetails
    orderHistory: OrderHistoryReturn
    orderFilenames: OrderFilenames
    orderMiscInfo?: OrderMiscInfoReturnPayload
    invalidLines: Record<
        RowId,
        {
            partNumber?: boolean
            date?: boolean
            ExpectedOnDockDate?: boolean
            UnitPrice?: boolean
            SpecialInstructions?: boolean
        }
    >
    reviewingQuoteOutput: boolean
}

const initialState: OrderState = {
    currentModal: MODALS.NONE,
    dateValid: true,
    reviewingQuoteOutput: false,
    ccContacts: [],
    orderLoading: LOADING_STATES.INIT,
    showImages: true,
    webSubmitOrderURL: '',
    shippingInfo: {
        carrier: '',
        collectAccount: '',
        service: '',
        terms: '',
        carrierKey: 0,
        serviceKey: 0,
        termsKey: 0,
    },
    orderHeader: [],
    orderFilenames: [],
    invalidLines: {},
    orderHistory: [],
    searchLoading: LOADING_STATES.INIT,
    getOrderMiscInfoLoading: LOADING_STATES.INIT,
    saveBlockingProcessPendingCount: 0,
    addLineItemFromBOMLoading: LOADING_STATES.INIT,

    orderHistoryLoading: LOADING_STATES.INIT,
}

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        addAttachment: (state, actiom: PayloadAction<any>) => {},
        addInvalidLine: (state, action: PayloadAction<{ lineItemNumber: string }>) => {
            const { lineItemNumber } = action.payload
            let newLine = {
                OrderNumber: state.orderHeader[0].OrderNumber,
                LineItemNumber: lineItemNumber,
                CancelFlag: false,
                //@ts-ignore
                NeedDate: new Date().toISOString(),
                UnusualDemand: false,
                TransitTime: 0,
                //@ts-ignore
                OrderEntryDate: new Date().toISOString(),
                HighPriority: false,
                PartKey: -1,
                PartNumber: '',
                Description: '',
                SpecialInstructions: '',
                InternalInstructions: '',
                OrderQuantity: undefined,
                ShipQuantity: 0,
                UnitPrice: 0,
                IsAssembly: false,
                AssemblyType: ' ',
                QuantityReadyForShip: 0,
                CommissionPercentage: 0,
                QuoteNote: '',
                CustomerLineItemNumber: '',
                CustomerSpecificNotes: '',
                WorkOrderNumber: '',
                SymbolNumber: '',
                WasUpdated: true,
                QuotedDelivery: 0,
                QuotedDeliveryUOM: '',
                QuotedDeliveryOverride: '',
                LockInPONumber: '',
                LockInPOLineItemNumber: '',
                LockInOrderFromCode: '',
                LockInOrderFromName: '',
                LockInIsDropship: false,
                LockInOrdQty: 0,
                LockInShipQty: 0,
                LockInTransitTime: 0,
                LockInCost: 0,
                LockInFactorySpecifications: '',
                SORListPrice: 0,
                SORDiscount: 0,
                SORTagInfo: '',
                SORSetPoint: '',
                SORPlusMinus: '+',
                SORCustNumber: '',
                SORRepNo: '39',
                SORCustContact: '',
                SORTelephone: '',
                DesiredWarehouseQuantity: '',
                SalesProductCode: '',
                OperationsProductCode: '',
                LeadTime: 0,
                PartDescription: '',
                ListPrice: 0,
                Cost: 0,
                LockInVend_SO: '',
                LockInVend_Line_Item: '',
                LockInExp_Status: '',
                PriceOverrideDiff: 0,
                VendorContractNo: '',
                ReleaseQuantity: 0,
                NoPartials: false,
                MarketingCode: '',
                LastQuantityAcknowledged: -1,
                LastUnitPriceAcknowledged: -1,
                CustomerStatus: '1',
                Available: 0,
                OrderDetailId: -1,
                TechnicianInstructions: '',
                ServiceType: '',
                LockInTariff: 0,
                RebateBasis: 0,
                SalesPerson1: '',
                SalesPerson2: '',
                SalesPercentage: 0,
                Rebate: 0,
                PrintAssemblyComponentsOnAcknowledgement: true,
                PrintAssemblyComponentsOnQuote: true,
                PrintAssemblyComponentsOnDeliveryTicket: true,
                PrintAssemblyComponentsOnOrder: true,
                PrintAssemblyComponentsOnInvoice: true,
                OrderAssemblyDetailView: [],
                rowId: uuidv4(),
            }
            state.invalidLines[newLine.rowId] = {}
            state.orderHeader[0].OrderDetailView = [
                //@ts-ignore
                ...state.orderHeader[0].OrderDetailView,
                //@ts-ignore
                newLine,
            ]
        },
        deleteLine: (state, action: PayloadAction<{ rowId: string }>) => {
            let { rowId } = action.payload

            state.invalidLines[rowId] && delete state.invalidLines[rowId]
            let existingRowIndex = state.orderHeader[0].OrderDetailView.findIndex(
                (row) => row.rowId === rowId
            )!
            state.orderHeader[0].OrderDetailView.splice(existingRowIndex, 1)
            state.orderHeader[0].OrderDetailView.forEach((row, i) => {
                row.LineItemNumber = (i + 1).toString().padStart(3, '0')
            })
            if (!state.orderHeader[0].OrderDetailView.some((row) => row.temp)) {
                state.orderHeader[0].OrderDetailView.push(
                    makeTempRow(
                        state.orderHeader[0].OrderNumber,
                        state.orderHeader[0].OrderDetailView.length
                    )
                )
            }
        },
        incrementRevisionNumber: (state) => {
            state.orderHeader[0].Revision = state.orderHeader[0].Revision
                ? state.orderHeader[0].Revision + 1
                : 1
        },
        markRowInvalid: (
            state,
            action: PayloadAction<{
                rowId: string
                field: keyof OrderState['invalidLines']['string']
            }>
        ) => {
            const { rowId, field } = action.payload
            state.invalidLines[rowId] = state.invalidLines[rowId] || {}
            state.invalidLines[rowId][field] = true
        },
        markRowValid: (
            state,
            action: PayloadAction<{
                rowId: string
                field: keyof OrderState['invalidLines']['string']
            }>
        ) => {
            const { rowId, field } = action.payload
            state.invalidLines[rowId] &&
                state.invalidLines[rowId][field] &&
                delete state.invalidLines[rowId][field]
        },

        startQuoteInternal: (
            state,
            action: PayloadAction<{
                account: PACustomerContactViewRow
                shipTo?: CustomerShipToViewRow
                contact?: ContactCustomerAccountCodeViewRow
                customer: CustomerRow
                customerUniqueInfo: CustomerIDInfoRow
            }>
        ) => {
            let { account, shipTo, contact, customer, customerUniqueInfo } = action.payload
            state.currentAccount = account
            state.currentShipTo = shipTo
            state.currentCustomer = customer
            state.currentCustomerUniqueInfo = customerUniqueInfo

            setDefaultShippingInfo(
                state,
                customer,
                state.freightTerms!,
                state.carrierServiceOptions!
            )

            if (contact) state.toContact = contact
        },
        setCarrierAndFreight: (state, action: PayloadAction<FreightAndCarrierOptions>) => {
            const { carrierServiceOptions, freightTermsOptions } = action.payload
            state.freightTerms = freightTermsOptions
            state.carrierServiceOptions = carrierServiceOptions
        },
        setCurrentCustomer: (state, action: PayloadAction<CustomerRow>) => {
            state.currentCustomer = action.payload
            // TODO fix typings
            //@ts-ignore
            state.currentAccount = {
                ...action.payload,
                EmailAddress: '',
                ExactMatch: false,
            }
        },
        setCurrentCustomerUniqueInfo: (state, action: PayloadAction<CustomerIDInfoRow>) => {
            state.currentCustomerUniqueInfo = action.payload
        },
        setToContact: (state, action: PayloadAction<ContactCustomerAccountCodeViewRow>) => {
            state.toContact = action.payload
        },
        setCcContacts: (
            state,
            action: PayloadAction<Array<ContactCustomerAccountCodeViewRow | string>>
        ) => {
            state.ccContacts = action.payload
            state.orderHeader[0].EmailCC = action.payload
                .map((row) => (typeof row === 'string' ? row : row.EmailAddress!))
                .join(';')
        },
        setDateValidity: (state, action: PayloadAction<boolean>) => {
            state.dateValid = action.payload
        },
        setShowImages: (state, action: PayloadAction<boolean>) => {
            state.showImages = action.payload
        },
        setReviewingQuoteOutput: (state, action: PayloadAction<boolean>) => {
            state.reviewingQuoteOutput = action.payload
        },
        setCurrentAccountNull: (state) => {
            state.currentAccount = undefined
        },
        setToContactNull: (state) => {
            state.toContact = undefined
        },
        incrementSaveBlockingProcessPendingCount: (state) => {
            state.saveBlockingProcessPendingCount += 1
        },
        decrementSaveBlockingProcessPendingCount: (state) => {
            state.saveBlockingProcessPendingCount -= 1
        },
        setHistoryDetailsNull: (state) => {
            state.orderHistoryLoading = LOADING_STATES.INIT
            state.orderHistoryDetails = undefined
        },
        setSearchCustomerState: (state, action: PayloadAction<LOADING_STATES>) => {
            state.searchLoading = action.payload
        },
        setLoadingState: (state, action: PayloadAction<LOADING_STATES>) => {
            state.orderLoading = action.payload
        },
        setAddLineItemFromBOMLoading: (state, action: PayloadAction<LOADING_STATES>) => {
            state.addLineItemFromBOMLoading = action.payload
        },
        setReferenceNumber: (state, action: PayloadAction<string>) => {
            state.orderHeader[0].RFQNumber = action.payload
        },
        setQuoteOpenNotes: (state, action: PayloadAction<string>) => {
            state.orderHeader[0].QuoteOpenNotes = action.payload
        },
        setQuoteCloseNotes: (state, action: PayloadAction<string>) => {
            state.orderHeader[0].QuoteCloseNotes = action.payload
        },
        setShipmentMethodDescription: (state, action: PayloadAction<string>) => {
            state.orderHeader[0].ShipmentMethodDescription = action.payload
        },
        updateValidUntilDate: (state, action: PayloadAction<Date | null>) => {
            if (action.payload) {
                state.orderHeader[0].QuoteExpirationDate = new Date(action.payload).toISOString()
            } else {
                state.orderHeader[0].QuoteExpirationDate = undefined
            }
        },

        // email address payload
        removeCc: (state, action: PayloadAction<string>) => {
            state.ccContacts = state.ccContacts.filter((row) =>
                typeof row === 'string'
                    ? row !== action.payload
                    : row.EmailAddress !== action.payload
            )
        },
        updateCartName: (state, action: PayloadAction<string>) => {
            state.orderHeader[0].CartName = action.payload
        },
        updateTaxAuthorityCode: (state, action: PayloadAction<string>) => {
            state.orderHeader[0].TaxAuthorityCode = action.payload
        },
        updateAvailabilityMode: (state, action: PayloadAction<string>) => {
            state.orderHeader[0].AvailabilityMode = action.payload
        },
        updateLine2: (
            state,
            action: PayloadAction<
                { rowId: string } & Partial<PayloadOrderDetailViewRow> &
                    RowMetaInfo & { priceInfo?: FetchPriceReturnPayload }
            >
        ) => {
            let {
                rowId,
                rebateStatus,
                priceInfo,
                priceStatistics,
                partsAvailability,
                partInfo,
                estimatedDelivery,
                vendorName,
                leadTimeHistory,
                dataSheets,
                ...newFields
            } = action.payload

            state.invalidLines[rowId] && delete state.invalidLines[rowId].partNumber
            state.invalidLines[rowId] &&
                newFields.OriginalOnDockDate &&
                delete state.invalidLines[rowId].date
            let existingRowIndex = state.orderHeader[0].OrderDetailView.findIndex(
                (row) => row.rowId === rowId
            )!
            let existingRow = state.orderHeader[0].OrderDetailView[existingRowIndex]
            // existingRow.metaInfo.rebateStatus = rebateStatus
            let isNewRow =
                !existingRow.metaInfo ||
                (newFields.PartKey && existingRow.PartKey !== newFields.PartKey)

            if (isNewRow) {
                existingRow = {
                    ...existingRow,
                    rowId: existingRow.rowId,
                    SpecialInstructions: '',
                    Cost: priceInfo!.Cost!,
                    UnitPrice:
                        priceInfo!.CustomerPrice! === 0 ? undefined : priceInfo!.CustomerPrice!,
                    OrderQuantity: undefined,
                    MarketingCode: partInfo?.MarketingCode,
                    // defaults to match .net
                    QuotedDeliveryUOM: 'D',
                    TransitTime: 1,
                }
            }
            // let newOrderDetailView = [...state.orderHeader[0].OrderDetailView]
            // needDate <-> orderHeader OriginalOnDockDate
            // initialDeliveryDate <-> orderHeader NeedDate
            // userOverrideDate <-> orderHeader ExpectedOnDockDate
            existingRow = {
                ...existingRow,
                ...newFields,
                NeedDate: newFields?.NeedDate || existingRow?.NeedDate,
                OriginalOnDockDate:
                    // newFields?.OriginalOnDockDate,
                    newFields?.OriginalOnDockDate || existingRow?.OriginalOnDockDate,
                ExpectedOnDockDate:
                    newFields?.ExpectedOnDockDate || existingRow?.ExpectedOnDockDate,
                Rebate: priceInfo!.CustomerRebate,
                metaInfo: {
                    ...existingRow.metaInfo,
                    rebateStatus: rebateStatus || existingRow.metaInfo?.rebateStatus,
                    priceInfo,
                    dataSheets: dataSheets || existingRow.metaInfo?.dataSheets,
                    partInfo: partInfo || existingRow.metaInfo?.partInfo,
                    priceStatistics: priceStatistics || existingRow.metaInfo?.priceStatistics,
                    partsAvailability: partsAvailability || existingRow.metaInfo?.partsAvailability,
                    estimatedDelivery: estimatedDelivery || existingRow.metaInfo?.estimatedDelivery,
                    leadTimeHistory: leadTimeHistory || existingRow.metaInfo?.leadTimeHistory,
                    vendorName: vendorName || existingRow.metaInfo?.vendorName,
                },
            }
            // needDate on screen <-> orderHeader OriginalOnDockDate
            // initialDeliveryDate <-> orderHeader NeedDate
            // userOverrideDate <-> orderHeader ExpectedOnDockDate
            if (estimatedDelivery) {
                // if (!existingRow.NeedDate) {
                existingRow.NeedDate = estimatedDelivery.EstimatedDeliveryDate
                // }
            }
            // if they blanked out expected delivery date, reset to undefined
            if (newFields.hasOwnProperty('ExpectedOnDockDate') && !newFields.ExpectedOnDockDate) {
                existingRow.ExpectedOnDockDate = undefined
            }
            // if they blanked out need date, reset to undefined
            if (newFields.hasOwnProperty('OriginalOnDockDate') && !newFields.OriginalOnDockDate) {
                existingRow.OriginalOnDockDate = undefined
            }
            let wasTempRow = existingRow.temp
            if (wasTempRow) {
                state.orderHeader[0].OrderDetailView.push(
                    makeTempRow(
                        existingRow.OrderNumber,
                        state.orderHeader[0].OrderDetailView.length
                    )
                )
                existingRow.temp = false
            }
            state.orderHeader[0].OrderDetailView[existingRowIndex] = { ...existingRow }
        },

        updateFileName: (state, action: PayloadAction<{ fileId: number; fileName: string }>) => {
            let { fileId, fileName } = action.payload
            let updatingRow = state.orderFilenames.find((row) => row.FileId === fileId)
            updatingRow!.FriendlyFilename = fileName
        },
        updateIncludeInEmail: (
            state,
            action: PayloadAction<{ fileId: number; includeWithOrder: boolean }>
        ) => {
            let { fileId, includeWithOrder } = action.payload
            let updatingRow = state.orderFilenames.find((row) => row.FileId === fileId)
            updatingRow!.IncludeWithOrder = includeWithOrder
            // can't be internal if including with order
            if (includeWithOrder) updatingRow!.Internal = false
        },
        updateShippingInfo: (state, action: PayloadAction<Partial<ShippingInfo>>) => {
            let shippingInfo = action.payload

            if (shippingInfo.carrierKey) {
                state.shippingInfo.carrierKey = shippingInfo.carrierKey
                state.shippingInfo.carrier = state.carrierServiceOptions!.find(
                    (row) => row.CarrierKey === shippingInfo.carrierKey
                )!.CarrierName
            }
            if (shippingInfo.serviceKey) {
                state.shippingInfo.serviceKey = shippingInfo.serviceKey
                let carrier = state.carrierServiceOptions!.find(
                    (row) => row.CarrierKey === shippingInfo.carrierKey
                )!
                let service = carrier.CarrierServices.find(
                    (row) => row.CarrierServiceKey === shippingInfo.serviceKey
                )!.ServiceName
                state.shippingInfo.service = service
            }
            if (shippingInfo.termsKey) {
                state.shippingInfo.termsKey = shippingInfo.termsKey
                state.shippingInfo.terms = state.freightTerms!.find(
                    (row) => row.TermsKey === shippingInfo.termsKey
                )!.ShortDescription
            }

            if (shippingInfo.termsKey === 3 || shippingInfo.termsKey === 5) {
                if (shippingInfo.collectAccount !== undefined) {
                    state.shippingInfo.collectAccount = shippingInfo.collectAccount
                }
            } else {
                state.shippingInfo.collectAccount = ''
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(initOrder.pending, (state) => {
                state.orderLoading = LOADING_STATES.LOADING
            })
            .addCase(initOrder.fulfilled, (state, action) => {
                state.orderLoading = LOADING_STATES.DONE
                state.orderHeader = action.payload
                // defaulting to match .net
                state.orderHeader[0].AvailabilityMode =
                    state.currentCustomer!.AvailabilityMode !== 'C' &&
                    state.currentCustomer!.AvailabilityMode !== 'D'
                        ? 'C'
                        : state.currentCustomer!.AvailabilityMode
                state.orderHeader[0].CustomerAccountCode = state.currentCustomer!.AccountCode
                state.orderHeader[0].TaxAuthorityCode =
                    state.currentShipTo?.TaxAuthorityCode || 'TEMP'
            })
            .addCase(initOrder.rejected, (state, action) => {
                if (action.error.name === 'AbortError') {
                    state.orderLoading = LOADING_STATES.DONE
                } else {
                    state.orderLoading = LOADING_STATES.FAILED
                }
            })

        builder
            .addCase(saveOrder.pending, (state) => {})
            .addCase(saveOrder.fulfilled, (state, action) => {
                let newOrderNumber = action.payload.OrderHeaderView[0].OrderNumber
                let newOrderFilenames = action.payload.OrderHeaderView[0].OrderFilenames
                updateOrderNumber(state, newOrderNumber)
                updateOrderFileIds(state, newOrderFilenames)
            })
            .addCase(saveOrder.rejected, (state, action) => {
                // console.log(`state:`)
                // console.log(state)
                // console.log(`action:`)
                // console.log(action)
            })

        builder
            .addCase(uploadAttachment.pending, (state) => {})
            .addCase(uploadAttachment.fulfilled, (state, action) => {
                let { contentType, fileName } = action.meta.arg
                let { SystemFilename, SystemFilenameExtension } = action.payload
                let minId = 0
                state.orderFilenames.forEach((row) => {
                    minId = Math.min(row.FileId, minId)
                })
                minId -= 1
                let newAttachment: OrderFilenamesRow = {
                    FriendlyFilename: fileName,
                    IncludeWithOrder: false,
                    ContentType: contentType,
                    FileId: minId,
                    Internal: true,
                    OrderNumber: state.orderHeader[0].OrderNumber,
                    SystemFilename: SystemFilename,
                    SystemFilenameExtension: SystemFilenameExtension,
                    UploadedTimestamp: new Date(),
                }
                state.orderFilenames.push(newAttachment)
            })
            .addCase(uploadAttachment.rejected, (state, action) => {})

        builder
            .addCase(deleteAttachment.pending, (state) => {})
            .addCase(deleteAttachment.fulfilled, (state, action) => {
                let deletedFileId = action.meta.arg
                let deletedIndex = state.orderFilenames.findIndex(
                    (row) => row.FileId === deletedFileId
                )
                state.orderFilenames.splice(deletedIndex, 1)
            })
            .addCase(deleteAttachment.rejected, (state, action) => {})

        builder
            .addCase(updateAttachment.pending, (state) => {})
            .addCase(updateAttachment.fulfilled, (state, action) => {
                let { fileId, internal } = action.meta.arg
                let updatedRow = state.orderFilenames.find((row) => row.FileId === fileId)
                if (updatedRow) {
                    updatedRow.Internal = internal
                    // can't be included with order if internal
                    if (internal) {
                        updatedRow.IncludeWithOrder = false
                    }
                }
            })
            .addCase(updateAttachment.rejected, (state, action) => {})

        builder
            .addCase(getOrderMiscInfo.pending, (state) => {
                state.getOrderMiscInfoLoading = LOADING_STATES.LOADING
                state.saveBlockingProcessPendingCount += 1
            })
            .addCase(getOrderMiscInfo.fulfilled, (state, action) => {
                state.getOrderMiscInfoLoading = LOADING_STATES.DONE
                state.saveBlockingProcessPendingCount -= 1
                state.orderMiscInfo = action.payload
            })

        builder
            .addCase(loadHistory.pending, (state) => {
                state.orderHistoryLoading = LOADING_STATES.LOADING
            })
            .addCase(loadHistory.fulfilled, (state, action) => {
                // if fulfilled after account swap
                if (
                    action.meta.arg.customerAccountCode.trim() !==
                        state.currentAccount?.AccountCode.trim() &&
                    !state.currentAccount?.OrderNumberExactMatch
                )
                    return

                if (!state.currentAccount) {
                    return
                }
                const { orderHistory: history, contact } = action.payload
                history.forEach(
                    (row) => (row.Contact = `${row.Contact}<${row.ContactEmailAddress}>`)
                )
                const customerUniqueInfo = state.currentCustomerUniqueInfo!
                history.forEach(
                    (row) =>
                        (row.UniqueCustomerName =
                            row.UniqueCustomerId === state.currentCustomer?.UniqueCustomerID
                                ? customerUniqueInfo.UniqueCustomerName.replace('||', ' - ') || ''
                                : '')
                )

                state.orderHistory = history
                //TODO memoize
                const contactEmails = history.filter(
                    (row) => row.ContactEmailAddress.toLowerCase() === contact.toLowerCase()
                )
                const contactDomain = contact ? contact.split('@')[1] : ''
                const domainEmails = history.filter(
                    (row) => row.ContactEmailDomain?.toLowerCase() === contactDomain.toLowerCase()
                )
                const customerEmails = history.filter(
                    (row) => row.UniqueCustomerId === state.currentCustomer?.UniqueCustomerID
                )
                // assuming these are sorted
                const customerMostRecent = history.find(
                    (row) => row.UniqueCustomerId === state.currentCustomer?.UniqueCustomerID
                )
                const contactMostRecent = history.find(
                    (row) => row.ContactEmailAddress.toLowerCase() === contact.toLowerCase()
                )
                const domainMostRecent = history.find(
                    (row) => row.ContactEmailDomain?.toLowerCase() === contactDomain.toLowerCase()
                )

                let newOrderHistoryDetails: OrderHistoryDetails = {
                    contact: contact,
                    contactAmount: contactEmails.length,
                    contactMostRecent: contactMostRecent!,
                    customer: customerUniqueInfo.UniqueCustomerName
                        ? customerUniqueInfo.UniqueCustomerName.replace('||', ' - ')
                        : '',
                    customerAmount: customerEmails.length,
                    customerMostRecent: customerMostRecent!,
                    domain: contactDomain,
                    domainAmount: domainEmails.length,
                    domainMostRecent: domainMostRecent!,
                }

                state.orderHistoryLoading = LOADING_STATES.DONE
                state.orderHistoryDetails = newOrderHistoryDetails
            })
            .addCase(loadHistory.rejected, (state, action) => {
                state.orderHistoryLoading = LOADING_STATES.DONE
            })
        builder
            .addCase(addLineItemFromBOM.pending, (state) => {
                state.addLineItemFromBOMLoading = LOADING_STATES.LOADING
            })
            .addCase(addLineItemFromBOM.fulfilled, (state, action) => {
                const {
                    dataSheets,
                    partInfo,
                    rebateStatus,
                    partsAvailability,
                    priceInfo,
                    vendorName,
                    leadTimeHistory,
                } = action.payload

                let newLine = action.meta.arg.LineItem
                newLine.LineItemNumber = state.orderHeader[0].OrderDetailView.length
                    .toString()
                    .padStart(3, '0')
                newLine.Cost = priceInfo.Cost
                newLine.UnitPrice =
                    priceInfo!.CustomerPrice! === 0 ? undefined : priceInfo!.CustomerPrice!
                newLine.MarketingCode = partInfo?.MarketingCode
                newLine.QuotedDeliveryUOM = 'D'
                newLine.TransitTime = 1
                const tempLine = {
                    ...newLine,
                    rowId: uuidv4(),
                    temp: false,
                    metaInfo: {
                        dataSheets,
                        partInfo,
                        rebateStatus,
                        partsAvailability,
                        priceInfo,
                        vendorName,
                        leadTimeHistory,
                    },
                }
                state.orderHeader[0].OrderDetailView = [
                    //@ts-ignore
                    ...state.orderHeader[0].OrderDetailView,
                    //@ts-ignore
                    tempLine,
                ]

                state.orderHeader[0].OrderDetailView.find((line) => {
                    if (line.temp) {
                        line.LineItemNumber = state.orderHeader[0].OrderDetailView.length
                            .toString()
                            .padStart(3, '0')
                    }
                })

                state.orderHeader[0].OrderDetailView.sort((a: any, b: any) => a.temp - b.temp)
            })

        builder.addCase(loadOrder.pending, (state, action) => {})
        builder.addCase(loadOrder.fulfilled, (state, action) => {
            let newOrderHeader = action.payload.order.OrderHeaderView[0]

            let newCustomer = action.payload.customer!

            // TODO fix typings
            //@ts-ignore
            state.currentAccount = {
                ...newCustomer,
                EmailAddress: '',
                ExactMatch: false,
                CustomerTypeName: Object.entries(CUSTOMER_TYPES).find(
                    (row) => row[1].typeId === newCustomer.CustomerType
                )?.[1].typeText,
            }
            state.currentCustomer = action.payload.customer
            state.toContact = action.payload.toContact
            state.ccContacts = action.payload.ccContacts
            state.currentShipTo = {
                AccountCode: newCustomer.AccountCode.trim(),
                AvailabilityMode: 'a',
                QuoteAttachmentFormats: 'a',
                ShipToID: -1,
                ShipToAddress1: newOrderHeader.ShipToAddress1,
                ShipToAddress2: newOrderHeader.ShipToAddress2,
                ShipToAddress3: newOrderHeader.ShipToAddress3,
                ShipToState: newOrderHeader.ShipToState,
                ShipToZipcode: newOrderHeader.ShipToZipcode,
                ShipToCity: newOrderHeader.ShipToCity,
                ShipToCountry: newOrderHeader.ShipToCountry,
                TaxAuthorityCode: newOrderHeader.TaxAuthorityCode,
                ShipToName: newOrderHeader.ShipToName,
            }
            // give the loaded rows rowIds
            newOrderHeader.OrderDetailView.forEach((row) => {
                row.rowId = uuidv4()
                row.temp = false
            })
            // mark invalid if dates in past
            let invalidRows: OrderState['invalidLines'] = {}
            newOrderHeader.OrderDetailView.forEach((row) => {
                // if theres a need date and it's in the past it's invalid
                if (row.OriginalOnDockDate && new Date(row.OriginalOnDockDate) < new Date()) {
                    invalidRows[row.rowId] = { date: true }
                }
            })
            state.invalidLines = invalidRows

            newOrderHeader.OrderDetailView.push(
                makeTempRow(newOrderHeader.OrderNumber, newOrderHeader.OrderDetailView.length)
            )

            state.orderHeader[0] = newOrderHeader
            // this got flattened into OrderHeader
            let newMiscInfo: OrderMiscInfoReturnPayload = {
                CreditStatus: newOrderHeader.CreditStatus,
                OrderValue: newOrderHeader.OrderValue,
                SalesPersonAssignments: newOrderHeader.SalesPersonAssignments,
                Tax: newOrderHeader.Tax,
            }

            state.dateValid =
                !!newOrderHeader.QuoteExpirationDate &&
                new Date() < new Date(newOrderHeader.QuoteExpirationDate)
            state.orderMiscInfo = newMiscInfo
            setDefaultShippingInfo(
                state,
                newCustomer,
                state.freightTerms!,
                state.carrierServiceOptions!
            )
            state.orderFilenames = newOrderHeader.OrderFilenames
            state.orderLoading = LOADING_STATES.DONE
            state.searchLoading = LOADING_STATES.DONE
            // state.orderMiscInfo = action.payload.OrderHeaderView.OrderMiscInfo
        })
        builder.addCase(loadOrder.rejected, (state, action) => {
            // fqAlert({ type: 'error', title: 'Failed to load order' })
        })
        builder.addCase(updateShipmentMethodDescription.fulfilled, (state, action) => {
            let shipmentMethodDescription = action.payload.ShipmentMethodString
            let orderDetailView = action.payload.OrderDetailView

            state.orderHeader[0].ShipmentMethodDescription = shipmentMethodDescription

            state.orderHeader[0].OrderDetailView.filter((row) => !row.temp).forEach((row) => {
                const newRow = orderDetailView.find(
                    (detailRow: any) => detailRow.rowId === row.rowId
                )
                if (newRow && !newRow.temp) {
                    // NeedDate as OriginalOnDockDate
                    // InitialEstimatedDeliveryDate as NeedDate
                    // UserOverride as ExpectedOnDockDate

                    row.metaInfo = newRow.metaInfo
                    row.NeedDate = newRow.metaInfo.estimatedDelivery.EstimatedDeliveryDate
                }
            })
        })
        builder.addCase(updateShipTo.fulfilled, (state, action) => {
            let shipTo = action.payload.shipTo
            let orderDetailView = action.payload.OrderDetailView

            state.currentShipTo = shipTo
            // update current customer if it is a new default
            if (shipTo.isDefault && state.currentCustomer) {
                state.currentCustomer.ShipToAddress1 = shipTo.ShipToAddress1
                state.currentCustomer.ShipToAddress2 = shipTo.ShipToAddress2
                state.currentCustomer.ShipToZipcode = shipTo.ShipToZipcode
                state.currentCustomer.ShipToCity = shipTo.ShipToCity
                state.currentCustomer.ShipToState = shipTo.ShipToState
                state.currentCustomer.ShipToName = shipTo.ShipToName
            }
            state.orderHeader[0].OrderDetailView.filter((row) => !row.temp).forEach((row) => {
                const newRow = orderDetailView.find(
                    (detailRow: any) => detailRow.rowId === row.rowId
                )
                if (newRow) {
                    row.metaInfo = newRow.metaInfo
                    row.NeedDate = newRow.metaInfo.estimatedDelivery.EstimatedDeliveryDate
                }
            })
        })
        builder.addCase(updateOrder.pending, (state) => {
            state.searchLoading = LOADING_STATES.LOADING
        })
        builder.addCase(updateOrder.fulfilled, (state, action) => {
            // TODO refactor -- this is basically the same as loadOrder.fulfilled
            let newOrderHeader = action.payload.order.OrderHeaderView[0]

            let newCustomer = action.payload.customer!

            // TODO fix typings
            //@ts-ignore
            state.currentAccount = {
                ...newCustomer,
                EmailAddress: '',
                ExactMatch: false,
                CustomerTypeName: Object.entries(CUSTOMER_TYPES).find(
                    (row) => row[1].typeId === newCustomer.CustomerType
                )?.[1].typeText,
            }
            state.currentCustomer = action.payload.customer
            state.toContact = action.payload.toContact
            state.ccContacts = action.payload.ccContacts
            state.currentShipTo = {
                AccountCode: newCustomer.AccountCode.trim(),
                AvailabilityMode: 'a',
                QuoteAttachmentFormats: 'a',
                ShipToID: -1,
                ShipToAddress1: newOrderHeader.ShipToAddress1,
                ShipToAddress2: newOrderHeader.ShipToAddress2,
                ShipToAddress3: newOrderHeader.ShipToAddress3,
                ShipToState: newOrderHeader.ShipToState,
                ShipToZipcode: newOrderHeader.ShipToZipcode,
                ShipToCity: newOrderHeader.ShipToCity,
                ShipToCountry: newOrderHeader.ShipToCountry,
                TaxAuthorityCode: newOrderHeader.TaxAuthorityCode,
                ShipToName: newOrderHeader.ShipToName,
            }
            // give the loaded rows rowIds
            newOrderHeader.OrderDetailView.forEach((row) => {
                row.rowId = uuidv4()
                row.temp = false
            })

            // mark invalid if dates in past
            let invalidRows: OrderState['invalidLines'] = {}
            newOrderHeader.OrderDetailView.forEach((row) => {
                // if theres a need date and it's in the past it's invalid
                if (row.OriginalOnDockDate && new Date(row.OriginalOnDockDate) < new Date()) {
                    invalidRows[row.rowId] = { date: true }
                }
            })
            state.invalidLines = invalidRows

            newOrderHeader.OrderDetailView.push(
                makeTempRow(newOrderHeader.OrderNumber, newOrderHeader.OrderDetailView.length)
            )

            state.orderHeader[0] = newOrderHeader
            // this got flattened into OrderHeader
            let newMiscInfo: OrderMiscInfoReturnPayload = {
                CreditStatus: newOrderHeader.CreditStatus,
                OrderValue: newOrderHeader.OrderValue,
                SalesPersonAssignments: newOrderHeader.SalesPersonAssignments,
                Tax: newOrderHeader.Tax,
            }

            state.dateValid =
                !!newOrderHeader.QuoteExpirationDate &&
                new Date() < new Date(newOrderHeader.QuoteExpirationDate)

            state.orderMiscInfo = newMiscInfo
            setDefaultShippingInfo(
                state,
                newCustomer,
                state.freightTerms!,
                state.carrierServiceOptions!
            )
            state.orderFilenames = newOrderHeader.OrderFilenames
            state.orderLoading = LOADING_STATES.DONE
            state.searchLoading = LOADING_STATES.DONE
            // state.orderMiscInfo = action.payload.OrderHeaderView.OrderMiscInfo
        })
        builder.addCase(updateOrder.rejected, (state, action) => {
            // fqAlert({ type: 'error', title: 'Failed to load order' })
        })
        builder.addCase(quitQuote.fulfilled, (state, action) => {
            for (let key in state) {
                //@ts-ignore
                state[key] = initialState.hasOwnProperty(key) ? initialState[key] : undefined
            }
        })
        builder.addCase(forceReleaseOrderLock.fulfilled, (state, action) => {
            for (let key in state) {
                //@ts-ignore
                state[key] = initialState.hasOwnProperty(key) ? initialState[key] : undefined
            }
        })

        builder.addMatcher(
            isAnyOf(
                updateOrder.fulfilled,
                saveOrder.fulfilled,
                loadOrder.fulfilled,
                (v: any): v is any => v.type === 'order/startQuoteInternal'
            ),
            (state) => {
                saveSnapShot = JSON.parse(JSON.stringify(state))
            }
        )
    },
})
export const isNewOrderSelector = (state: RootState) => {
    return state.order.orderHeader[0].OrderNumber === '9999999999'
}

// export const usePriceStatisticsSelector = (state: RootState, Partkey: number) => {
//     return usePricingStatistics({
//         CustomerAccountCode: state.order.currentAccount!.AccountCode,
//         Partkey,
//     })
// }
export const selectNumDecimals = (state: RootState) =>
    Math.max(
        2,
        state.order.orderHeader[0]?.OrderDetailView.reduce(
            (prev, current) =>
                Math.max(
                    prev,
                    current.Cost ? getNumDecimalPlaces(current.Cost) : 0,
                    current.UnitPrice ? getNumDecimalPlaces(current.UnitPrice) : 0
                ),
            0
        ) || 0
    )
export const {
    addInvalidLine,
    deleteLine,
    markRowInvalid,
    markRowValid,

    removeCc,
    setCcContacts,
    setDateValidity,
    setReferenceNumber,
    setQuoteOpenNotes,
    setQuoteCloseNotes,
    setReviewingQuoteOutput,
    setCurrentAccountNull,
    setShipmentMethodDescription,
    setLoadingState,
    setAddLineItemFromBOMLoading,
    incrementSaveBlockingProcessPendingCount,
    decrementSaveBlockingProcessPendingCount,
    setSearchCustomerState,
    setToContactNull,
    setHistoryDetailsNull,
    setToContact,
    setShowImages,
    updateCartName,
    updateTaxAuthorityCode,
    updateAvailabilityMode,
    updateValidUntilDate,
    updateFileName,
    updateIncludeInEmail,
    updateShippingInfo,
    updateLine2,
} = orderSlice.actions

export default orderSlice.reducer
